var _defs, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapitan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capitan",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_293",
    "data-name": "Elipse 293",
    cx: 80.801,
    cy: 80.801,
    r: 80.801,
    transform: "translate(1663.5 974.4) rotate(-45)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_554",
    "data-name": "Rect\\xE1ngulo 554",
    width: 157.71,
    height: 42.211,
    transform: "translate(0 0.001)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8147",
    "data-name": "Grupo 8147",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6206",
    "data-name": "Grupo 6206",
    transform: "translate(-434.168 -293.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6204",
    "data-name": "Grupo 6204"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_218",
    "data-name": "Elipse 218",
    cx: 3.97,
    cy: 3.97,
    r: 3.97,
    transform: "translate(590.639 351.598)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6205",
    "data-name": "Grupo 6205"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_219",
    "data-name": "Elipse 219",
    cx: 3.126,
    cy: 3.126,
    r: 3.126,
    transform: "matrix(0.474, -0.88, 0.88, 0.474, 599.938, 369.577)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6201",
    "data-name": "Grupo 6201",
    transform: "translate(-434.168 -293.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_841",
    "data-name": "Trazado 841",
    d: "M471.335,487.108a10.055,10.055,0,0,0-.948,14.356,118.7,118.7,0,0,0,175.485,1.763,10.016,10.016,0,0,0-1.278-14.731l-85.448-65.813a10.032,10.032,0,0,0-12.631.314Z",
    fill: "#655dc6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_842",
    "data-name": "Trazado 842",
    d: "M546.582,423l-73.7,62.852C495.2,509.511,527,525.925,561.96,525.054c31.974-.8,60.671-16.231,81.5-37.486l-84.244-64.885A10.032,10.032,0,0,0,546.582,423Z",
    transform: "translate(-434.168 -293.873)",
    fill: "#524ba4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_215",
    "data-name": "Elipse 215",
    cx: 99.071,
    cy: 99.071,
    r: 99.071,
    transform: "translate(25 18.274)",
    fill: "#ffde00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_216",
    "data-name": "Elipse 216",
    cx: 89.464,
    cy: 89.464,
    r: 89.464,
    transform: "translate(35 27.882)",
    fill: "#fc9a05"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_217",
    "data-name": "Elipse 217",
    cx: 80.801,
    cy: 80.801,
    r: 80.801,
    transform: "translate(10 115.27) rotate(-45)",
    fill: "#02daff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1580",
    "data-name": "Trazado 1580",
    d: "M600.608,469.058a1.111,1.111,0,1,1-1.111-1.11A1.111,1.111,0,0,1,600.608,469.058Z",
    transform: "translate(-434.168 -293.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1581",
    "data-name": "Trazado 1581",
    d: "M616.211,449.687a1.111,1.111,0,1,1-1.11-1.111A1.111,1.111,0,0,1,616.211,449.687Z",
    transform: "translate(-434.168 -293.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6678",
    "data-name": "Grupo 6678",
    transform: "translate(-434.168 -293.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1582",
    "data-name": "Trazado 1582",
    d: "M521.109,445.219A1.111,1.111,0,1,1,520,444.108,1.111,1.111,0,0,1,521.109,445.219Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1583",
    "data-name": "Trazado 1583",
    d: "M525.158,469a1.111,1.111,0,1,1-1.111-1.111A1.111,1.111,0,0,1,525.158,469Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1584",
    "data-name": "Trazado 1584",
    d: "M511.431,465.883a1.111,1.111,0,1,1-1.111-1.111A1.111,1.111,0,0,1,511.431,465.883Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1585",
    "data-name": "Trazado 1585",
    d: "M494.975,381.649a3.265,3.265,0,0,1-1.519,1.619.307.307,0,0,0,0,.551,3.261,3.261,0,0,1,1.519,1.619.308.308,0,0,0,.56,0,3.261,3.261,0,0,1,1.519-1.619.307.307,0,0,0,0-.551,3.265,3.265,0,0,1-1.519-1.619A.308.308,0,0,0,494.975,381.649Z",
    transform: "translate(-434.168 -293.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6679",
    "data-name": "Grupo 6679",
    transform: "translate(-434.168 -293.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1586",
    "data-name": "Trazado 1586",
    d: "M490.208,421.48a1.111,1.111,0,1,1-1.111-1.111A1.111,1.111,0,0,1,490.208,421.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1587",
    "data-name": "Trazado 1587",
    d: "M501.827,440.034a3.267,3.267,0,0,1-1.519,1.62.307.307,0,0,0,0,.55,3.263,3.263,0,0,1,1.519,1.62.308.308,0,0,0,.56,0,3.263,3.263,0,0,1,1.519-1.62.307.307,0,0,0,0-.55,3.267,3.267,0,0,1-1.519-1.62A.308.308,0,0,0,501.827,440.034Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1588",
    "data-name": "Trazado 1588",
    d: "M510.9,404.623a3.265,3.265,0,0,1-1.519,1.619.307.307,0,0,0,0,.551,3.261,3.261,0,0,1,1.519,1.619.308.308,0,0,0,.56,0,3.26,3.26,0,0,1,1.519-1.619.307.307,0,0,0,0-.551,3.264,3.264,0,0,1-1.519-1.619A.308.308,0,0,0,510.9,404.623Z",
    transform: "translate(-5.132 11.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2932",
    "data-name": "Trazado 2932",
    d: "M510.9,404.623a3.265,3.265,0,0,1-1.519,1.619.307.307,0,0,0,0,.551,3.261,3.261,0,0,1,1.519,1.619.308.308,0,0,0,.56,0,3.26,3.26,0,0,1,1.519-1.619.307.307,0,0,0,0-.551,3.264,3.264,0,0,1-1.519-1.619A.308.308,0,0,0,510.9,404.623Z",
    transform: "translate(-3.162 -10.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2933",
    "data-name": "Trazado 2933",
    d: "M490.208,421.48a1.111,1.111,0,1,1-1.111-1.111A1.111,1.111,0,0,1,490.208,421.48Z",
    transform: "translate(11 8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2934",
    "data-name": "Trazado 2934",
    d: "M490.208,421.48a1.111,1.111,0,1,1-1.111-1.111A1.111,1.111,0,0,1,490.208,421.48Z",
    transform: "translate(19 -44)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1589",
    "data-name": "Trazado 1589",
    d: "M597.007,447.864a4.437,4.437,0,0,1-2.064,2.2.417.417,0,0,0,0,.748,4.437,4.437,0,0,1,2.064,2.2.418.418,0,0,0,.76,0,4.438,4.438,0,0,1,2.065-2.2.418.418,0,0,0,0-.748,4.438,4.438,0,0,1-2.065-2.2A.418.418,0,0,0,597.007,447.864Z",
    transform: "translate(-434.168 -293.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1590",
    "data-name": "Trazado 1590",
    d: "M607.518,400.51a1.111,1.111,0,1,1-1.11-1.111A1.111,1.111,0,0,1,607.518,400.51Z",
    transform: "translate(-425.168 -298.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1591",
    "data-name": "Trazado 1591",
    d: "M615.1,413.96a1.111,1.111,0,1,1-1.111-1.111A1.111,1.111,0,0,1,615.1,413.96Z",
    transform: "translate(-429.168 -284.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1592",
    "data-name": "Trazado 1592",
    d: "M626.769,382.433a1.111,1.111,0,1,1-1.11-1.111A1.11,1.11,0,0,1,626.769,382.433Z",
    transform: "translate(-434.168 -293.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1593",
    "data-name": "Trazado 1593",
    d: "M630.62,393.267a.395.395,0,1,1-.4-.395A.4.4,0,0,1,630.62,393.267Z",
    transform: "translate(-434.168 -293.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1594",
    "data-name": "Trazado 1594",
    d: "M631.015,415.211a.4.4,0,1,1-.4-.395A.394.394,0,0,1,631.015,415.211Z",
    transform: "translate(-439.524 -298.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1595",
    "data-name": "Trazado 1595",
    d: "M597.247,407.679a3.267,3.267,0,0,1-1.519,1.62.307.307,0,0,0,0,.55,3.263,3.263,0,0,1,1.519,1.62.308.308,0,0,0,.56,0,3.263,3.263,0,0,1,1.519-1.62.307.307,0,0,0,0-.55,3.267,3.267,0,0,1-1.519-1.62A.308.308,0,0,0,597.247,407.679Z",
    transform: "translate(-419.368 -294.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1596",
    "data-name": "Trazado 1596",
    d: "M623.047,427.046a4.434,4.434,0,0,1-2.065,2.2.418.418,0,0,0,0,.748,4.436,4.436,0,0,1,2.065,2.2.418.418,0,0,0,.76,0,4.434,4.434,0,0,1,2.064-2.2.417.417,0,0,0,0-.748,4.432,4.432,0,0,1-2.064-2.2A.418.418,0,0,0,623.047,427.046Z",
    transform: "translate(-438.4 -286.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1597",
    "data-name": "Trazado 1597",
    d: "M492.9,401.869a4.445,4.445,0,0,1-2.064,2.2.417.417,0,0,0,0,.748,4.437,4.437,0,0,1,2.064,2.2.418.418,0,0,0,.76,0,4.432,4.432,0,0,1,2.064-2.2.417.417,0,0,0,0-.748,4.44,4.44,0,0,1-2.064-2.2A.418.418,0,0,0,492.9,401.869Z",
    transform: "translate(-434.168 -293.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_1",
    "data-name": "Enmascarar grupo 1",
    transform: "translate(-1653.5 -857.692)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8119",
    "data-name": "Grupo 8119",
    transform: "translate(1706 984.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8062",
    "data-name": "Grupo 8062",
    transform: "translate(1.037 1.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8061",
    "data-name": "Grupo 8061"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3043",
    "data-name": "Trazado 3043",
    d: "M836.652,2422.163c-19.462,5.96-43.973,9.51-70.6,9.51s-51.137-3.55-70.6-9.508c0-.029,0-.06,0-.089-.005-.274-.01-.547-.016-.823v-.06q-.028-2,.066-4.01c.01-.26.024-.523.039-.783a70.014,70.014,0,0,1,1.02-8.62q.252-1.387.562-2.772.233-1.04.5-2.073c.118-.46.242-.917.368-1.377.063-.228.129-.457.194-.686q.2-.686.41-1.372.426-1.368.909-2.728c.163-.452.328-.9.5-1.353q.386-1.013.8-2.024.28-.671.573-1.337c.1-.224.2-.447.3-.67q1.206-2.669,2.652-5.277.847-1.521,1.758-2.985c.192-.307.384-.615.578-.92.06-.092.121-.181.179-.273.155-.239.31-.476.468-.712q.434-.651.878-1.285c.11-.163.226-.326.342-.486.081-.118.166-.234.25-.35.168-.233.336-.465.507-.7.223-.3.449-.6.678-.9s.46-.6.691-.891.468-.589.7-.878a0,0,0,0,1,0,0c.2-.252.41-.5.615-.746.066-.076.129-.15.189-.223.166-.2.331-.392.5-.583.089-.1.176-.205.266-.3.2-.231.407-.462.612-.691.25-.276.5-.552.752-.822s.507-.542.762-.81c.229-.239.46-.475.691-.712.042-.042.082-.084.124-.126.239-.242.481-.48.723-.717a.141.141,0,0,1,.026-.026q.788-.777,1.6-1.516.406-.374.817-.741c.552-.494,1.114-.977,1.682-1.453q.41-.343.825-.678t.857-.683c.339-.268.683-.531,1.028-.791.236-.179.473-.357.712-.531.292-.215.586-.428.88-.638.4-.287.8-.565,1.206-.841.168-.116.336-.229.507-.342.1-.066.194-.132.294-.195.139-.095.279-.187.421-.279.076-.05.152-.1.231-.149.026-.016.052-.034.079-.05q.438-.288.883-.562.887-.556,1.792-1.083c.2-.119.4-.234.607-.352.6-.344,1.217-.68,1.832-1.006l.617-.323q1.664-.863,3.369-1.637.852-.386,1.714-.749,1.727-.725,3.482-1.361,1.317-.477,2.651-.9,2.669-.843,5.4-1.48,1.817-.425,3.661-.749,1.782-.316,3.579-.539c.076-.01.152-.021.229-.029.583-.071,1.167-.136,1.753-.192.623-.06,1.246-.11,1.868-.155.31-.021.623-.039.936-.058.089,0,.176-.013.263-.015.3-.016.612-.031.92-.042s.612-.023.92-.031.625-.013.936-.019q1.36-.015,2.725.016l.78.024q.777.027,1.553.073c.778.047,1.558.105,2.336.176.518.047,1.033.1,1.55.161h0a70.831,70.831,0,0,1,25.27,7.92q.485.26.964.528c.549.3,1.093.613,1.632.936.326.192.649.386.967.586.339.208.673.415,1.006.628.446.283.887.574,1.325.866.1.07.212.136.315.207s.218.147.328.226c.3.205.6.413.9.623l.142.1c.292.2.581.415.87.625.315.231.625.463.936.7s.617.471.92.71.607.481.907.723.6.489.894.736.589.5.878.749.578.5.865.762.568.512.849.773q.843.772,1.653,1.582,2.034,2,3.876,4.155,1.112,1.285,2.147,2.622c.229.3.457.594.683.894s.449.6.67.9q1,1.36,1.916,2.767c.2.3.4.607.591.912l.039.063c.192.3.384.609.57.914s.386.639.578.959.376.641.56.964c.37.646.731,1.3,1.075,1.955s.686,1.319,1.012,1.987q.244.5.481,1,.714,1.51,1.348,3.051c.142.344.281.686.418,1.03q.816,2.061,1.5,4.17c.005.021.013.039.018.061.11.336.215.673.318,1.009.11.355.215.71.321,1.064s.2.712.3,1.067.194.715.286,1.075c.084.331.168.662.247,1,.016.063.031.129.047.192.076.323.152.647.223.97.163.723.315,1.448.452,2.176.068.365.136.728.2,1.093s.126.73.184,1.1.113.733.166,1.1c.047.336.095.67.137,1.007.005.052.013.1.021.155.039.329.079.654.116.983,0,.029.005.06.01.089.039.36.076.72.11,1.083s.068.738.1,1.109q.091,1.112.142,2.226Q836.713,2419.637,836.652,2422.163Z",
    transform: "translate(-695.426 -2349.79)",
    fill: "#ffd243"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8064",
    "data-name": "Grupo 8064",
    transform: "translate(1.039 1.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8063",
    "data-name": "Grupo 8063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3044",
    "data-name": "Trazado 3044",
    d: "M836.7,2421.313c0,.246-.008.49-.013.74,0,.039,0,.075,0,.114-.622.189-1.247.379-1.883.565q-2.914.856-5.978,1.639-2.147.552-4.365,1.066c-4.769,1.1-9.762,2.08-14.947,2.912-.169.029-.34.054-.511.081a.189.189,0,0,1-.026.005c-.552.085-1.1.174-1.66.257q-2.159.323-4.357.617-.969.129-1.94.25a282.18,282.18,0,0,1-34.935,2.119,269.958,269.958,0,0,1-50.351-4.544q-1.175-.222-2.329-.459c-5.633-1.141-10.989-2.458-16.025-3.937-.635-.187-1.268-.376-1.893-.568h0c0-.028,0-.059,0-.088,0-.187-.008-.374-.01-.56,0-.085,0-.174-.005-.262v-.062c0-.145,0-.3,0-.443q-.008-1.144.023-2.285c.01-.428.026-.856.044-1.281q0-.144.015-.288a.274.274,0,0,1,.005-.064c.005-.143.013-.288.021-.431s.016-.27.026-.407c.016-.283.036-.568.054-.851.044-.592.1-1.18.156-1.769q.276-2.8.783-5.592c.169-.925.358-1.851.563-2.772.153-.7.319-1.385.5-2.075.119-.459.241-.916.368-1.377.062-.228.13-.456.194-.685.132-.459.267-.916.41-1.372.283-.913.589-1.821.91-2.729.161-.451.327-.9.5-1.354.257-.675.526-1.351.8-2.023q.28-.669.573-1.338c.1-.223.2-.447.3-.669q1.206-2.665,2.651-5.273.848-1.525,1.758-2.99c.192-.306.384-.615.578-.918.06-.093.119-.181.179-.275.153-.239.309-.475.467-.711q.432-.653.877-1.286c.112-.164.228-.327.342-.485q.125-.179.249-.35c.169-.233.337-.464.508-.7q.335-.456.677-.9c.231-.3.462-.6.693-.892s.467-.589.7-.876a0,0,0,0,1,0,0c.208-.251.412-.5.617-.747l.189-.223q.245-.3.5-.583c.091-.1.176-.2.265-.306.2-.231.407-.461.612-.69.252-.275.5-.552.752-.822s.508-.542.762-.81c.228-.238.459-.477.693-.713.041-.042.08-.083.122-.125.239-.244.482-.482.724-.718a.122.122,0,0,1,.026-.026c.527-.516,1.056-1.019,1.6-1.517.27-.249.545-.5.817-.741q.829-.74,1.683-1.453.409-.342.825-.677c.283-.233.571-.462.856-.685.34-.267.685-.531,1.027-.791.228-.171.454-.343.682-.509l.031-.023c.29-.215.586-.428.879-.638q.6-.428,1.208-.841c.166-.117.335-.228.506-.342.1-.065.194-.129.3-.195l.651-.427.078-.05c.293-.189.586-.376.884-.56.591-.371,1.19-.734,1.792-1.084.2-.119.4-.236.607-.352q.91-.518,1.831-1.007c.2-.109.412-.215.617-.324q1.665-.864,3.369-1.637c.568-.257,1.141-.509,1.714-.749,1.152-.482,2.308-.939,3.481-1.362.879-.314,1.761-.615,2.653-.9q2.669-.844,5.4-1.481,1.821-.42,3.662-.749,1.782-.315,3.579-.537c.075-.01.15-.021.228-.029.583-.073,1.167-.135,1.753-.192q.93-.09,1.867-.156l.936-.059c.088,0,.176-.011.265-.013.309-.018.612-.031.918-.044s.615-.021.921-.029.622-.015.934-.021q1.362-.015,2.726.016l.781.023c.516.019,1.035.044,1.554.073.778.05,1.559.106,2.334.177.519.049,1.037.1,1.551.16h0a71.075,71.075,0,0,1,25.271,7.921q.482.26.965.529c.55.306,1.092.615,1.631.939.327.19.648.387.967.586.337.207.672.415,1.006.625.664.423,1.323.856,1.968,1.3q.451.307.9.622l.143.1c.293.2.581.415.871.625.314.231.625.462.934.7s.617.469.921.708.607.482.905.723.6.488.895.737.589.5.877.747.578.506.866.762.568.514.848.773c.56.521,1.113,1.045,1.652,1.582q2.031,2.008,3.877,4.155,1.109,1.288,2.148,2.622c.228.3.457.594.682.894s.451.6.672.9q.992,1.365,1.914,2.767.3.455.591.913l.039.063c.192.306.384.61.571.916s.386.638.578.959.376.641.56.965c.368.646.729,1.3,1.076,1.953s.685,1.32,1.011,1.987c.161.334.322.669.48,1.006q.708,1.51,1.349,3.05c.143.345.28.685.418,1.03q.817,2.062,1.5,4.171c.005.02.013.039.018.06.109.337.215.675.316,1.011.111.353.215.708.322,1.063s.2.713.3,1.066.195.716.288,1.077c.083.329.169.661.246,1,.016.062.031.127.047.191.078.322.153.646.223.97q.245,1.081.454,2.176c.067.364.135.726.2,1.092s.124.731.184,1.1.112.732.166,1.1c.047.337.093.672.135,1.007.005.054.013.106.021.156.042.329.08.654.117.983,0,.029.005.06.01.091.028.26.054.519.078.781.013.1.021.2.031.3.039.371.07.739.1,1.11s.052.719.075,1.079c.044.62.073,1.24.1,1.862.013.293.021.583.028.876.005.223.01.449.013.672C836.7,2420.032,836.7,2420.675,836.7,2421.313Z",
    transform: "translate(-695.457 -2349.794)",
    fill: "#ffd243"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8066",
    "data-name": "Grupo 8066",
    transform: "translate(29.712 1.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8065",
    "data-name": "Grupo 8065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3045",
    "data-name": "Trazado 3045",
    d: "M1217.134,2368.644c-19.277,20.651-35.107-11.2-52.773-6.81-6.413,1.595-11.2,6.316-26.7,5.615-6.369-.288-9.23-2.082-10.509-3.851l.031-.023c.291-.215.586-.428.879-.638q.6-.428,1.209-.841c.166-.117.334-.228.506-.342.1-.065.194-.129.3-.195l.651-.427.078-.05c.293-.189.586-.376.884-.56.591-.371,1.191-.734,1.792-1.084.2-.119.4-.236.607-.352q.91-.518,1.831-1.007c.2-.109.412-.215.617-.324q1.665-.864,3.369-1.637c.568-.257,1.141-.509,1.714-.749,1.151-.482,2.308-.939,3.481-1.362.879-.314,1.761-.615,2.653-.9q2.669-.844,5.4-1.481,1.821-.42,3.662-.749,1.781-.315,3.579-.537c.075-.01.15-.021.228-.029.583-.073,1.167-.135,1.753-.192q.929-.09,1.867-.156l.936-.059c.088,0,.176-.011.265-.013.309-.018.612-.031.918-.044s.615-.021.921-.029.622-.015.934-.021q1.362-.015,2.726.016l.781.023c.516.019,1.035.044,1.554.073.778.05,1.559.106,2.334.177.519.049,1.037.1,1.551.16h0a71.066,71.066,0,0,1,25.271,7.921q.483.26.965.529c.55.306,1.092.615,1.631.939.327.19.648.387.967.586q.506.311,1.006.625c.664.423,1.323.856,1.969,1.3q.451.307.9.622l.143.1c.293.2.581.415.871.625.314.231.625.462.933.7s.617.469.921.708.607.482.905.723.6.488.895.737.589.5.877.747.578.506.866.762S1216.854,2368.385,1217.134,2368.644Z",
    transform: "translate(-1127.154 -2349.794)",
    fill: "#ff9d33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8068",
    "data-name": "Grupo 8068",
    transform: "translate(1.039 64.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8067",
    "data-name": "Grupo 8067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3046",
    "data-name": "Trazado 3046",
    d: "M695.805,3307.086a71.169,71.169,0,0,0,1.572,9.361q-.954-.28-1.892-.568c-.008-.215-.013-.431-.016-.649-.005-.255-.008-.51-.008-.767q-.008-1.143.024-2.287.02-.784.06-1.568a.53.53,0,0,1,0-.064c.013-.279.029-.559.047-.838s.037-.567.055-.851C695.695,3308.263,695.747,3307.675,695.805,3307.086Z",
    transform: "translate(-695.459 -3307.086)",
    fill: "#fcac38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8070",
    "data-name": "Grupo 8070",
    transform: "translate(140.382 64.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8069",
    "data-name": "Grupo 8069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3047",
    "data-name": "Trazado 3047",
    d: "M2795.282,3316.5c0,.247-.008.491-.013.738,0,.04,0,.076,0,.115-.623.189-1.248.379-1.882.565.029-.118.058-.236.084-.355a69.244,69.244,0,0,0,1.4-8.225c.024-.219.048-.439.068-.657a.023.023,0,0,0,0-.013c.01.105.021.208.029.313.037.371.068.739.1,1.109s.053.72.076,1.08c.042.62.071,1.24.094,1.863.013.292.021.583.029.875.005.223.011.449.013.672C2795.287,3315.22,2795.29,3315.862,2795.282,3316.5Z",
    transform: "translate(-2793.384 -3308.669)",
    fill: "#fcac38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8072",
    "data-name": "Grupo 8072",
    transform: "translate(114.554 63.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8071",
    "data-name": "Grupo 8071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3048",
    "data-name": "Trazado 3048",
    d: "M2424.379,3306.557q-2.148.552-4.365,1.065c-4.77,1.106-9.763,2.081-14.948,2.914l-.51.079-.026.005c.018-.092.04-.184.061-.276,1.929-8.6,7.695-15.589,12.877-15.6,2.6-.008,4.68,1.8,5.863,4.688A16.688,16.688,0,0,1,2424.379,3306.557Z",
    transform: "translate(-2404.53 -3294.742)",
    fill: "#ff9d33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8074",
    "data-name": "Grupo 8074",
    transform: "translate(106.597 73.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8073",
    "data-name": "Grupo 8073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3049",
    "data-name": "Trazado 3049",
    d: "M2288.727,3433.933l0,.005a19.689,19.689,0,0,0-2.048,6.83c0,.047-.01.095-.013.142-.644.084-1.291.168-1.939.247.034-.224.073-.447.115-.67a15.013,15.013,0,0,1,3.243-6.988.392.392,0,0,1,.552-.04A.387.387,0,0,1,2288.727,3433.933Z",
    transform: "translate(-2284.725 -3433.365)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8076",
    "data-name": "Grupo 8076",
    transform: "translate(32.214 23.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8075",
    "data-name": "Grupo 8075",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_286",
    "data-name": "Elipse 286",
    cx: 7.018,
    cy: 5.986,
    rx: 7.018,
    ry: 5.986,
    transform: "translate(0 0.898) rotate(-3.667)",
    fill: "#ff9d33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8078",
    "data-name": "Grupo 8078",
    transform: "translate(34.735 25.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8077",
    "data-name": "Grupo 8077",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_287",
    "data-name": "Elipse 287",
    cx: 5.273,
    cy: 4.255,
    rx: 5.273,
    ry: 4.255,
    transform: "translate(0 3.661) rotate(-20.313)",
    fill: "#ffd243"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8080",
    "data-name": "Grupo 8080",
    transform: "translate(31.547 22.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8079",
    "data-name": "Grupo 8079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3050",
    "data-name": "Trazado 3050",
    d: "M1163.047,2685.787a8.17,8.17,0,0,1-4.537-.786,7.628,7.628,0,0,1-1.937-1.4,6.534,6.534,0,0,1-1.351-2.04,6.159,6.159,0,0,1,.13-4.874,6.929,6.929,0,0,1,1.429-2.011,7.911,7.911,0,0,1,1.966-1.438,9.637,9.637,0,0,1,2.277-.8,9,9,0,0,1,4.746.291,8.01,8.01,0,0,1,2.127,1.115,6.42,6.42,0,0,1,2.594,3.953,5.664,5.664,0,0,1-1.029,4.476.233.233,0,0,1-.392-.249,5.293,5.293,0,0,0,.476-4.008,5.551,5.551,0,0,0-2.382-3.121,7.77,7.77,0,0,0-7.7-.283,6.241,6.241,0,0,0-2.733,2.729,4.851,4.851,0,0,0-.229,3.73,5.9,5.9,0,0,0,2.532,2.99,8.261,8.261,0,0,0,3.99,1.159h0a.289.289,0,0,1,.021.575Z",
    transform: "translate(-1154.78 -2672.245)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8082",
    "data-name": "Grupo 8082",
    transform: "translate(28.886 25.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8081",
    "data-name": "Grupo 8081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3051",
    "data-name": "Trazado 3051",
    d: "M1134.479,2712.545a7.779,7.779,0,0,1,1.718,4.177,8.238,8.238,0,0,1-.909,4.526,9.764,9.764,0,0,1-3.044,3.482,11.907,11.907,0,0,1-4.2,1.885,12.684,12.684,0,0,1-4.578.2,11.363,11.363,0,0,1-4.314-1.526,9.61,9.61,0,0,1-3.261-3.183,7.952,7.952,0,0,1-1.159-4.332.233.233,0,0,1,.463-.019v0a8.055,8.055,0,0,0,1.5,3.808,9.184,9.184,0,0,0,3.089,2.608,11.354,11.354,0,0,0,7.906.933,10.8,10.8,0,0,0,3.672-1.624,9.716,9.716,0,0,0,1.531-1.292c.22-.25.44-.5.641-.766a8.951,8.951,0,0,0,.548-.833l.244-.436c.075-.148.131-.3.2-.456a6.638,6.638,0,0,0,.325-.941,2.922,2.922,0,0,0,.113-.486l.094-.492c.018-.333.058-.667.058-1a7.794,7.794,0,0,0-1.109-3.905.289.289,0,0,1,.472-.33Z",
    transform: "translate(-1114.727 -2712.441)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8084",
    "data-name": "Grupo 8084",
    transform: "translate(18.981 45.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8083",
    "data-name": "Grupo 8083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3052",
    "data-name": "Trazado 3052",
    d: "M978.862,3039.963a20.022,20.022,0,0,1-6.578,10.651c-.194.178-.41.334-.617.494l-.633.479-.66.433c-.221.145-.442.289-.675.413l-.691.381c-.229.131-.476.231-.709.347-.121.06-.244.118-.368.174q-1.175-.226-2.331-.46l.079-.032c.226-.092.455-.176.67-.289l.657-.318c.221-.1.426-.234.639-.349s.426-.229.628-.366l.607-.4a7.1,7.1,0,0,0,.589-.423l.581-.431.552-.47c.184-.157.373-.308.541-.481a20.058,20.058,0,0,0,3.574-4.507,19.422,19.422,0,0,0,2.113-5.325,17.262,17.262,0,0,0,.4-5.673,15.4,15.4,0,0,0-1.519-5.445,13.294,13.294,0,0,0-1.516-2.4,12.47,12.47,0,0,0-1.995-2.034,13.615,13.615,0,0,0-5.135-2.622l0,0a.389.389,0,0,1,.147-.762,12.222,12.222,0,0,1,3.054.741,13.421,13.421,0,0,1,5.222,3.59,14.824,14.824,0,0,1,1.863,2.62,16.4,16.4,0,0,1,1.932,6.1A18.646,18.646,0,0,1,978.862,3039.963Z",
    transform: "translate(-965.599 -3020.545)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8086",
    "data-name": "Grupo 8086",
    transform: "translate(3.982 48.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8085",
    "data-name": "Grupo 8085",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_288",
    "data-name": "Elipse 288",
    cx: 12.176,
    cy: 10.091,
    rx: 12.176,
    ry: 10.091,
    transform: "translate(0 23.978) rotate(-79.948)",
    fill: "#ff9d33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8088",
    "data-name": "Grupo 8088",
    transform: "translate(11.55 51.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8087",
    "data-name": "Grupo 8087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3053",
    "data-name": "Trazado 3053",
    d: "M857.85,3131.375c3.59.042,7.24-2.4,9.116-6.506,2.495-5.468.9-11.817-3.57-14.183a7.5,7.5,0,0,0-1.951-.714,12.419,12.419,0,0,0-6.43,6.462C852.481,3121.987,853.778,3128.367,857.85,3131.375Z",
    transform: "translate(-853.717 -3109.971)",
    fill: "#ffd243"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8090",
    "data-name": "Grupo 8090",
    transform: "translate(6.274 50.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8089",
    "data-name": "Grupo 8089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3054",
    "data-name": "Trazado 3054",
    d: "M774.309,3106.277a12.548,12.548,0,0,1,4.489-5.422,11.694,11.694,0,0,1,3.3-1.524,10.266,10.266,0,0,1,3.686-.329,8.73,8.73,0,0,1,3.587,1.1,9.6,9.6,0,0,1,2.9,2.414,11.169,11.169,0,0,1,2.273,7.009,13.279,13.279,0,0,1-7.623,11.695,10.31,10.31,0,0,1-7.169.582,8.99,8.99,0,0,1-3.177-1.721,8.82,8.82,0,0,1-2.192-2.789.31.31,0,0,1,.533-.313l0,0a8.7,8.7,0,0,0,2.265,2.309,8.169,8.169,0,0,0,2.9,1.262,8.334,8.334,0,0,0,3.125.089,9.935,9.935,0,0,0,2.978-.962,11.83,11.83,0,0,0,6.294-10.179,9.31,9.31,0,0,0-1.81-5.728,7.718,7.718,0,0,0-2.251-1.969,6.493,6.493,0,0,0-1.369-.634c-.239-.079-.482-.151-.728-.21s-.5-.089-.753-.137a9.572,9.572,0,0,0-6.017,1.264,12.657,12.657,0,0,0-4.564,4.54l0,0a.384.384,0,0,1-.682-.35Z",
    transform: "translate(-774.278 -3098.958)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8092",
    "data-name": "Grupo 8092",
    transform: "translate(58.684 59.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8091",
    "data-name": "Grupo 8091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3055",
    "data-name": "Trazado 3055",
    d: "M1601.454,3230.812a17.4,17.4,0,0,1-.3,7.194,18.023,18.023,0,0,1-1.277,3.435,17.7,17.7,0,0,1-1.985,3.1,18.047,18.047,0,0,1-5.681,4.678,19.146,19.146,0,0,1-7.068,2.073,20.261,20.261,0,0,1-7.307-.677,20.809,20.809,0,0,1-11.631-8.355,19.649,19.649,0,0,1-2.847-6.571.31.31,0,0,1,.593-.174l0,.005a20.883,20.883,0,0,0,8.269,10.525,21.07,21.07,0,0,0,6.117,2.677,19.105,19.105,0,0,0,6.609.515,17.476,17.476,0,0,0,11.537-5.865,17.051,17.051,0,0,0,3.282-5.774,18.687,18.687,0,0,0,.922-6.707.385.385,0,0,1,.763-.082Z",
    transform: "translate(-1563.351 -3230.493)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8094",
    "data-name": "Grupo 8094",
    transform: "translate(62.022 46.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8093",
    "data-name": "Grupo 8093",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_289",
    "data-name": "Elipse 289",
    cx: 12.743,
    cy: 11.618,
    rx: 12.743,
    ry: 11.618,
    transform: "translate(0 6.904) rotate(-15.716)",
    fill: "#ff9d33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8096",
    "data-name": "Grupo 8096",
    transform: "translate(66.348 55.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8095",
    "data-name": "Grupo 8095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3056",
    "data-name": "Trazado 3056",
    d: "M1678.744,3174.331a11.707,11.707,0,0,0,9.892,8.268c6.6.907,12.77-3.3,13.786-9.391a10.172,10.172,0,0,0,.106-2.545,13.38,13.38,0,0,0-8.954-5.144C1686.871,3164.6,1680.567,3168.462,1678.744,3174.331Z",
    transform: "translate(-1678.744 -3165.385)",
    fill: "#ffd243"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8098",
    "data-name": "Grupo 8098",
    transform: "translate(64.357 47.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8097",
    "data-name": "Grupo 8097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3057",
    "data-name": "Trazado 3057",
    d: "M1663.285,3054.171a13.379,13.379,0,0,1,7.386,3.512,13.907,13.907,0,0,1,2.589,3.31,13.149,13.149,0,0,1,1.434,3.995,11.366,11.366,0,0,1,.03,4.279,11.673,11.673,0,0,1-1.446,4.064,12.247,12.247,0,0,1-6.612,5.352,13.513,13.513,0,0,1-4.246.673l-1.075-.041-1.063-.143a12.8,12.8,0,0,1-2.077-.513,13.916,13.916,0,0,1-6.8-4.911,13.424,13.424,0,0,1-1.972-3.727,12.525,12.525,0,0,1-.663-4.145,11.91,11.91,0,0,1,.775-4.089,11,11,0,0,1,2.157-3.5.31.31,0,0,1,.477.393,11.085,11.085,0,0,0-2.118,7.171,11.423,11.423,0,0,0,.8,3.646,12.576,12.576,0,0,0,7.936,7.3,12.2,12.2,0,0,0,1.794.4l.911.115.915.024a11.467,11.467,0,0,0,3.576-.6,10.357,10.357,0,0,0,5.529-4.435,9.8,9.8,0,0,0,1.281-3.371,8.751,8.751,0,0,0,.2-1.811c0-.3,0-.61-.019-.914s-.067-.609-.1-.914a11.6,11.6,0,0,0-1.1-3.516,12.359,12.359,0,0,0-2.133-3.062,13.256,13.256,0,0,0-6.505-3.781h0a.384.384,0,0,1,.14-.754Z",
    transform: "translate(-1648.768 -3054.168)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8100",
    "data-name": "Grupo 8100",
    transform: "translate(65.657 6.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8099",
    "data-name": "Grupo 8099",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_290",
    "data-name": "Elipse 290",
    cx: 11.698,
    cy: 16.096,
    rx: 11.698,
    ry: 16.096,
    transform: "translate(0 23.093) rotate(-80.761)",
    fill: "#fcac38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8102",
    "data-name": "Grupo 8102",
    transform: "translate(65.657 6.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8101",
    "data-name": "Grupo 8101",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_291",
    "data-name": "Elipse 291",
    cx: 11.698,
    cy: 16.096,
    rx: 11.698,
    ry: 16.096,
    transform: "translate(0 23.093) rotate(-80.761)",
    fill: "#ff9d33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8104",
    "data-name": "Grupo 8104",
    transform: "translate(69.449 12.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8103",
    "data-name": "Grupo 8103",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_292",
    "data-name": "Elipse 292",
    cx: 8.913,
    cy: 12.264,
    rx: 8.913,
    ry: 12.264,
    transform: "matrix(0.161, -0.987, 0.987, 0.161, 0, 17.596)",
    fill: "#ffd243"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8106",
    "data-name": "Grupo 8106",
    transform: "translate(66.753 9.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8105",
    "data-name": "Grupo 8105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3058",
    "data-name": "Trazado 3058",
    d: "M1690.178,2476.479a10.079,10.079,0,0,0-2.862,3.159,8.029,8.029,0,0,0-1.025,3.992,8.976,8.976,0,0,0,1,3.993,12.945,12.945,0,0,0,2.476,3.395,18.838,18.838,0,0,0,7.256,4.411,20.9,20.9,0,0,0,8.449,1.139,14.389,14.389,0,0,0,7.8-2.792,8.459,8.459,0,0,0,2.511-3.136,7.827,7.827,0,0,0,.674-3.938,9.919,9.919,0,0,0-1.265-3.935,14.2,14.2,0,0,0-2.639-3.365,20.79,20.79,0,0,0-7.5-4.475h0a.309.309,0,0,1,.177-.592,20.07,20.07,0,0,1,8.19,4.108,15.246,15.246,0,0,1,3.088,3.552,11.127,11.127,0,0,1,1.648,4.524,9.349,9.349,0,0,1-.674,4.869,10.363,10.363,0,0,1-2.975,3.909,13.785,13.785,0,0,1-4.219,2.344,18.421,18.421,0,0,1-2.3.645,21.52,21.52,0,0,1-2.353.34,22.45,22.45,0,0,1-9.289-1.278,21.978,21.978,0,0,1-4.238-2.059,18.221,18.221,0,0,1-3.66-3,14.488,14.488,0,0,1-2.669-3.958,10.528,10.528,0,0,1-.934-4.73,9.185,9.185,0,0,1,1.484-4.559,10.011,10.011,0,0,1,1.542-1.81,11.533,11.533,0,0,1,1.882-1.392.384.384,0,0,1,.427.637Z",
    transform: "translate(-1684.839 -2474.325)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8108",
    "data-name": "Grupo 8108",
    transform: "translate(62.757 3.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8107",
    "data-name": "Grupo 8107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3059",
    "data-name": "Trazado 3059",
    d: "M1665.332,2416.252a10.958,10.958,0,0,0-.345-6.717,16.7,16.7,0,0,0-3.711-5.692,23.816,23.816,0,0,0-5.445-4.193,27.978,27.978,0,0,0-6.379-2.646,28.318,28.318,0,0,0-6.827-1.088,24.661,24.661,0,0,0-6.858.679,18.046,18.046,0,0,0-6.236,2.813,12.412,12.412,0,0,0-4.257,5.327h0a.31.31,0,0,1-.586-.2,12.4,12.4,0,0,1,4.036-6.155,18.3,18.3,0,0,1,6.588-3.448,24.6,24.6,0,0,1,7.36-.989,29.071,29.071,0,0,1,7.339,1.065,28.736,28.736,0,0,1,6.835,2.893,24.032,24.032,0,0,1,5.751,4.723,17.2,17.2,0,0,1,3.734,6.468,12.053,12.053,0,0,1,.49,3.742,10.851,10.851,0,0,1-.762,3.657.384.384,0,0,1-.728-.242Z",
    transform: "translate(-1624.677 -2393.945)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8110",
    "data-name": "Grupo 8110",
    transform: "translate(114.58 65.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8109",
    "data-name": "Grupo 8109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3060",
    "data-name": "Trazado 3060",
    d: "M2420.384,3334.309c-4.769,1.106-9.763,2.081-14.948,2.914l-.51.079c.042-.2.087-.4.134-.61,1.572-6.775,5.76-12.425,9.66-13.258a4.705,4.705,0,0,1,.865-.105C2419.324,3323.238,2421.3,3328,2420.384,3334.309Z",
    transform: "translate(-2404.926 -3323.328)",
    fill: "#ffd243"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8112",
    "data-name": "Grupo 8112",
    transform: "translate(112.893 63.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8111",
    "data-name": "Grupo 8111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3061",
    "data-name": "Trazado 3061",
    d: "M2400.28,3295.966a.382.382,0,0,1-.294.013.375.375,0,0,1-.2-.16l0-.005a7.239,7.239,0,0,0-2.736-2.7,5.82,5.82,0,0,0-3.629-.588,8.042,8.042,0,0,0-2.407.77,10.518,10.518,0,0,0-1.111.634,14.712,14.712,0,0,0-2.949,2.567,22.173,22.173,0,0,0-4.076,6.783,24.729,24.729,0,0,0-1.148,3.805l-.51.079-.026,0c-.552.087-1.1.173-1.661.258a26.138,26.138,0,0,1,1.432-4.906,24.581,24.581,0,0,1,1.971-3.855,20.566,20.566,0,0,1,2.662-3.432,17.021,17.021,0,0,1,1.614-1.482,14.032,14.032,0,0,1,1.811-1.259,10.376,10.376,0,0,1,4.236-1.419,7.052,7.052,0,0,1,4.38,1.033,7.445,7.445,0,0,1,1.675,1.488,9.062,9.062,0,0,1,1.158,1.853A.388.388,0,0,1,2400.28,3295.966Z",
    transform: "translate(-2379.525 -3291.045)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8114",
    "data-name": "Grupo 8114",
    transform: "translate(109.39 24.377)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8113",
    "data-name": "Grupo 8113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3062",
    "data-name": "Trazado 3062",
    d: "M2326.778,2703.134c.35,8.536,14.3,15.533,19.72,37.719,2.3,9.412,9.974-1.334,2.423-18.983C2341.922,2705.511,2326.531,2697.117,2326.778,2703.134Z",
    transform: "translate(-2326.775 -2701.187)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8116",
    "data-name": "Grupo 8116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8115",
    "data-name": "Grupo 8115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3063",
    "data-name": "Trazado 3063",
    d: "M680.877,2408.623a1.037,1.037,0,0,1-1.036-1.01,71.7,71.7,0,0,1,33.672-62.556c1.6-1,3.26-1.949,4.92-2.808a72.439,72.439,0,0,1,29.063-7.961l.125-.006c.056,0,.112-.007.169-.008.656-.037,1.269-.062,1.847-.074,1.191-.033,2.44-.036,3.7-.005a70.866,70.866,0,0,1,25.009,5.222,71.693,71.693,0,0,1,7.928,3.791c.535.3,1.105.622,1.661.955.324.188.657.392.985.6a71.63,71.63,0,0,1,34.191,62.849,1.037,1.037,0,1,1-2.074-.05,69.774,69.774,0,0,0-33.21-61.036c-.319-.2-.632-.391-.947-.574-.516-.309-1.018-.595-1.618-.931a69.667,69.667,0,0,0-7.7-3.68,68.791,68.791,0,0,0-24.28-5.07c-1.228-.03-2.44-.028-3.6,0-.561.012-1.152.036-1.811.072l-.133.007-.157.007a70.329,70.329,0,0,0-28.2,7.731c-1.611.834-3.217,1.75-4.776,2.726a69.474,69.474,0,0,0-32.7,60.742,1.038,1.038,0,0,1-1.01,1.064Z",
    transform: "translate(-679.816 -2334.173)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8118",
    "data-name": "Grupo 8118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8117",
    "data-name": "Grupo 8117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3064",
    "data-name": "Trazado 3064",
    d: "M680.877,2408.623a1.037,1.037,0,0,1-1.036-1.01,71.7,71.7,0,0,1,33.672-62.556c1.6-1,3.26-1.949,4.92-2.808a72.439,72.439,0,0,1,29.063-7.961l.125-.006c.056,0,.112-.007.169-.008.656-.037,1.269-.062,1.847-.074,1.191-.033,2.44-.036,3.7-.005a70.866,70.866,0,0,1,25.009,5.222,71.693,71.693,0,0,1,7.928,3.791c.535.3,1.105.622,1.661.955.324.188.657.392.985.6a71.63,71.63,0,0,1,34.191,62.849,1.037,1.037,0,1,1-2.074-.05,69.774,69.774,0,0,0-33.21-61.036c-.319-.2-.632-.391-.947-.574-.516-.309-1.018-.595-1.618-.931a69.667,69.667,0,0,0-7.7-3.68,68.791,68.791,0,0,0-24.28-5.07c-1.228-.03-2.44-.028-3.6,0-.561.012-1.152.036-1.811.072l-.133.007-.157.007a70.329,70.329,0,0,0-28.2,7.731c-1.611.834-3.217,1.75-4.776,2.726a69.474,69.474,0,0,0-32.7,60.742,1.038,1.038,0,0,1-1.01,1.064Z",
    transform: "translate(-679.816 -2334.173)",
    fill: "#371a45"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3158",
    "data-name": "Trazado 3158",
    d: "M558.168,493.52a82.3,82.3,0,1,1,82.3-82.3A82.394,82.394,0,0,1,558.168,493.52Zm0-161.6a79.3,79.3,0,1,0,79.3,79.3A79.391,79.391,0,0,0,558.168,331.917Z",
    transform: "translate(-433.704 -294.906)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8146",
    "data-name": "Grupo 8146",
    transform: "translate(-1870 -1221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7834",
    "data-name": "Grupo 7834",
    transform: "translate(1895.834 1235.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7833",
    "data-name": "Grupo 7833",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2935",
    "data-name": "Trazado 2935",
    d: "M2735.616,558.57a14.982,14.982,0,0,1,9.958-2.307c5.98.872,10.556,3.371,18.219,2.8,9.448-.7,15.919-11.027,15.919-11.027s-6.886-18.523-6.886-25.917a11.089,11.089,0,0,0-3.359.952c-4.794,2.152-8.858,7.1-13.808,8.29a9.131,9.131,0,0,1-2.208.26,10.867,10.867,0,0,1-2.286-.265c-5.371-1.176-9.772-5.829-18.137-4.477-.588.095-1.2.219-1.829.376C2731.2,527.258,2735.725,558.373,2735.616,558.57Z",
    transform: "translate(-2731.2 -522.121)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7836",
    "data-name": "Grupo 7836",
    transform: "translate(1894.861 1234.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7835",
    "data-name": "Grupo 7835",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2936",
    "data-name": "Trazado 2936",
    d: "M2746.909,545.466c.736,0,1.5-.027,2.294-.086,9.827-.729,16.4-11.042,16.673-11.48a.974.974,0,0,0,.087-.855c-.068-.184-6.825-18.442-6.825-25.578a.972.972,0,0,0-1.076-.966c-3.676.4-6.767,2.714-9.756,4.954-3.117,2.336-6.062,4.544-9.452,4.544h-.056c-2.492-.018-4.741-1.06-7.123-2.162-3.96-1.834-8.449-3.912-15.375-2.175a.972.972,0,0,0-.725,1.082c1.73,11.9,4.313,29.882,4.408,31.143a.971.971,0,0,0,1.534.819,14.114,14.114,0,0,1,9.254-2.137,52.318,52.318,0,0,1,5.681,1.247A39.335,39.335,0,0,0,2746.909,545.466Zm17.061-12.211c-1.271,1.838-7.084,9.607-14.911,10.188a34.656,34.656,0,0,1-12.12-1.506,54.617,54.617,0,0,0-5.887-1.289,15.666,15.666,0,0,0-9.3,1.674c-.239-1.949-.807-5.922-2-14.272-.893-6.23-1.794-12.445-2.121-14.7,5.773-1.2,9.562.551,13.231,2.25,2.578,1.193,5.012,2.321,7.925,2.342h.07c4.037,0,7.382-2.507,10.617-4.933,2.585-1.938,5.042-3.78,7.768-4.4C2757.77,515.984,2762.932,530.413,2763.97,533.255Zm-43.868,10.2h0Zm0,0v0Zm0,0v0Z",
    transform: "translate(-2715.566 -506.496)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7838",
    "data-name": "Grupo 7838",
    transform: "translate(1966.937 1289.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7837",
    "data-name": "Grupo 7837",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2937",
    "data-name": "Trazado 2937",
    d: "M1943.087,1380.446l.5,4.414.258,2.248,4.439,38.768s-2.661.153-6.245.071c-.7-.016-1.438-.041-2.2-.078-5.654-.27-12.543-1.2-15.262-3.987-4.063-4.167-5.6-25.28-2.485-33.808,1.426-3.909,9.423-5.922,15.123-6.875.637-.108,1.246-.2,1.813-.281C1941.428,1380.574,1943.087,1380.446,1943.087,1380.446Z",
    transform: "translate(-1920.447 -1380.446)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7840",
    "data-name": "Grupo 7840",
    transform: "translate(1966.937 1293.697)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7839",
    "data-name": "Grupo 7839",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2938",
    "data-name": "Trazado 2938",
    d: "M1943.592,1451.4l.258,2.248,3.525,30.782.914,7.986-.161.008-.1.005-.1,0-.078,0h-.032l-.158.006a.3.3,0,0,1-.038,0l-.146.006c-.07,0-.142.005-.218.007l-.17.006-.182.005-.244.008c-.17,0-.35.009-.54.012-.168.005-.344.008-.528.01-.212,0-.434.007-.665.008-.852.007-1.828,0-2.885-.021l-.627-.016-.45-.015c-.365-.013-.741-.028-1.119-.046-5.656-.27-12.543-1.2-15.26-3.987-3.347-3.43-4.981-18.352-3.713-28.277.07,8.581,1.618,17.69,4.14,20.275,1.247,1.279,3.519,2.147,6.17,2.739a1.48,1.48,0,0,0,1.707-1.938l-.009-.026a26,26,0,0,1-1.3-7.068c-.3-5.881.091-14.386,6.126-21.557A45.625,45.625,0,0,1,1943.592,1451.4Z",
    transform: "translate(-1920.447 -1451.399)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7842",
    "data-name": "Grupo 7842",
    transform: "translate(1965.964 1288.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7841",
    "data-name": "Grupo 7841",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2939",
    "data-name": "Trazado 2939",
    d: "M1927.683,1411.274c2.358,0,4-.089,4.222-.1l1.027-.059-5.427-47.381-.933.072c-1.98.152-19.42,1.677-21.824,8.262-1.486,4.07-2.062,11.329-1.5,18.944.215,2.933,1.153,12.744,4.208,15.876C1911.172,1410.7,1921.718,1411.274,1927.683,1411.274Zm3.082-1.994c-5.743.217-18.356-.091-21.924-3.75-3.778-3.873-5.22-24.717-2.269-32.8,1.581-4.331,13.629-6.367,19.216-6.909Z",
    transform: "translate(-1903.033 -1363.732)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7844",
    "data-name": "Grupo 7844",
    transform: "translate(1969.03 1315.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7843",
    "data-name": "Grupo 7843",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2940",
    "data-name": "Trazado 2940",
    d: "M2151.616,1794.673l7.672.052a1.5,1.5,0,0,1,1.449,1.134c.613,2.432,1.739,8.123-.528,10.182a5.916,5.916,0,0,1-7.122.273c-2.238-1.646-2.829-7.263-2.985-10.053A1.5,1.5,0,0,1,2151.616,1794.673Z",
    transform: "translate(-2150.1 -1794.673)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7846",
    "data-name": "Grupo 7846",
    transform: "translate(1969.475 1315.73)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7845",
    "data-name": "Grupo 7845",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2941",
    "data-name": "Trazado 2941",
    d: "M2160.293,1806.106c.615,2.431,1.739,8.123-.527,10.181a5.916,5.916,0,0,1-7.123.273c-1.375-1.014-2.129-3.528-2.541-5.963a6.419,6.419,0,0,0,1.751,2.765c4.1,3.476,6.674-1.127,6.674-1.127s.572,1.036.973,1.07c1.678.14.98-5.036.557-7.707A1.449,1.449,0,0,1,2160.293,1806.106Z",
    transform: "translate(-2150.102 -1805.598)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7848",
    "data-name": "Grupo 7848",
    transform: "translate(1968.263 1314.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7847",
    "data-name": "Grupo 7847",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2942",
    "data-name": "Trazado 2942",
    d: "M2144.935,1796.59a6.311,6.311,0,0,0,4.233-1.535c2.487-2.26,1.54-7.823.755-10.937a2.269,2.269,0,0,0-2.186-1.713l-7.673-.052h-.015a2.271,2.271,0,0,0-2.269,2.4c.218,3.9.967,8.914,3.3,10.628A6.537,6.537,0,0,0,2144.935,1796.59Zm-4.882-12.7,7.672.052a.737.737,0,0,1,.711.555c1.177,4.664,1.064,8.188-.3,9.428a5.139,5.139,0,0,1-6.153.223c-1.4-1.03-2.4-4.573-2.674-9.479a.738.738,0,0,1,.743-.779Z",
    transform: "translate(-2137.776 -1782.353)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7850",
    "data-name": "Grupo 7850",
    transform: "translate(1974.536 1317.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7849",
    "data-name": "Grupo 7849",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2943",
    "data-name": "Trazado 2943",
    d: "M2185.888,1849.74a3.1,3.1,0,0,0,.349-.272c.1-.087.191-.176.278-.269a5.425,5.425,0,0,0,.482-.574,6.464,6.464,0,0,0,.727-1.261,8.184,8.184,0,0,0,.669-2.726,14.333,14.333,0,0,0-.1-2.71c-.052-.443-.12-.885-.211-1.325a6.847,6.847,0,0,0-.39-1.322.228.228,0,0,0-.427.159l.009.029a6.57,6.57,0,0,1,.223,1.225c.043.425.065.854.072,1.285a13.474,13.474,0,0,1-.165,2.532,7.057,7.057,0,0,1-.812,2.286,5.133,5.133,0,0,1-.683.946,3.965,3.965,0,0,1-.406.392c-.07.061-.141.115-.213.167a1.511,1.511,0,0,1-.181.114.775.775,0,1,0,.547,1.45.786.786,0,0,0,.153-.078Z",
    transform: "translate(-2184.611 -1839.145)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7852",
    "data-name": "Grupo 7852",
    transform: "translate(1967.852 1294.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7851",
    "data-name": "Grupo 7851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2944",
    "data-name": "Trazado 2944",
    d: "M2161.055,1470.018c-.953-.072-1.9-.117-2.845-.151s-1.9-.049-2.853-.038-1.91.037-2.875.116a20.118,20.118,0,0,0-2.934.418.973.973,0,0,0,.44,1.895c.026-.006.052-.013.078-.021l.007,0a18.394,18.394,0,0,1,2.612-.593c.9-.151,1.823-.254,2.747-.341s1.855-.149,2.787-.2,1.87-.078,2.8-.085h.006a.5.5,0,0,0,.033-1Z",
    transform: "translate(-2148.796 -1469.827)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7854",
    "data-name": "Grupo 7854",
    transform: "translate(1944.471 1288.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7853",
    "data-name": "Grupo 7853"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2945",
    "data-name": "Trazado 2945",
    d: "M2053.291,1376.309s7.428,26.007,37.457,13.243c1.271-.539,2.582-1.146,3.935-1.834l.294-9.844.08-2.723.28-9.322a34.689,34.689,0,0,1-3.214,2.055c-1.066.619-2.363,1.307-3.835,1.98-4.78,2.183-11.416,4.19-18.064,2.878a20.408,20.408,0,0,1-7.607-3.187Z",
    transform: "translate(-2053.291 -1365.828)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7856",
    "data-name": "Grupo 7856",
    transform: "translate(1944.47 1292.1)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7855",
    "data-name": "Grupo 7855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2946",
    "data-name": "Trazado 2946",
    d: "M2059.07,1432.482s7.428,26.007,37.457,13.242c1.271-.539,2.582-1.146,3.935-1.834l.294-9.844c-4.839,3.6-13.26,14.059-25.395,7.972-6.194-3.1-.131-5.526.641-13.1a20.413,20.413,0,0,1-7.608-3.187Z",
    transform: "translate(-2059.07 -1425.727)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7858",
    "data-name": "Grupo 7858",
    transform: "translate(1943.499 1287.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7857",
    "data-name": "Grupo 7857",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2947",
    "data-name": "Trazado 2947",
    d: "M2060.866,1379.416c5.841,0,12.4-1.826,19.606-5.469a.972.972,0,0,0-.877-1.734c-10.936,5.528-20.209,6.7-27.563,3.5-8.047-3.508-11.413-11.382-12.244-13.674l8.2-5.944c6.114,3.887,13.738,4.439,22.1,1.59a44.114,44.114,0,0,0,11.177-5.717.972.972,0,0,0-1.165-1.555c-.177.132-17.8,13.088-31.591,3.7a.971.971,0,0,0-1.117.016l-9.325,6.757a.972.972,0,0,0-.364,1.054c.128.449,3.262,11.057,13.528,15.546A23.8,23.8,0,0,0,2060.866,1379.416Z",
    transform: "translate(-2037.669 -1350.217)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7860",
    "data-name": "Grupo 7860",
    transform: "translate(1963.445 1294.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7859",
    "data-name": "Grupo 7859",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2948",
    "data-name": "Trazado 2948",
    d: "M2309.873,1488.986a.964.964,0,0,0,.208-.023,6.81,6.81,0,0,0,4.733-3.493c3.27-5.991-.84-17.2-1.016-17.67a.971.971,0,0,0-1.821.678c.04.108,3.978,10.85,1.131,16.063a4.882,4.882,0,0,1-3.441,2.524.972.972,0,0,0,.206,1.921Z",
    transform: "translate(-2308.902 -1467.168)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7862",
    "data-name": "Grupo 7862",
    transform: "translate(1935.47 1233.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7861",
    "data-name": "Grupo 7861",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2949",
    "data-name": "Trazado 2949",
    d: "M2291.773,479.477l14.607,57.9,4.222,16.735,10.979,43.514,2.828,11.212,3.524-.889-3.656-14.494-10.143-40.2-4.066-16.121-14.77-58.549a1.818,1.818,0,0,0-1.761-1.372,1.878,1.878,0,0,0-.445.056A1.817,1.817,0,0,0,2291.773,479.477Z",
    transform: "translate(-2291.717 -477.216)",
    fill: "#ddd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7864",
    "data-name": "Grupo 7864",
    transform: "translate(1965.333 1349.343)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7863",
    "data-name": "Grupo 7863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2950",
    "data-name": "Trazado 2950",
    d: "M2291.717,2350.138l2.828,11.212,3.524-.889-3.656-14.493A9.014,9.014,0,0,1,2291.717,2350.138Z",
    transform: "translate(-2291.717 -2345.967)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7866",
    "data-name": "Grupo 7866",
    transform: "translate(1950.132 1293.021)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7865",
    "data-name": "Grupo 7865",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2951",
    "data-name": "Trazado 2951",
    d: "M2513.548,1440.769l4.222,16.735a6.066,6.066,0,0,0,3.532-.858l-4.066-16.121Z",
    transform: "translate(-2513.548 -1440.526)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7868",
    "data-name": "Grupo 7868",
    transform: "translate(1934.498 1232.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7867",
    "data-name": "Grupo 7867",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2952",
    "data-name": "Trazado 2952",
    d: "M2305.718,595.379l5.408-1.364-32.872-130.307a2.788,2.788,0,1,0-5.407,1.364Zm3.049-2.773-1.64.414L2274.73,464.6a.846.846,0,0,1,1.64-.414Z",
    transform: "translate(-2272.76 -461.601)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7870",
    "data-name": "Grupo 7870",
    transform: "translate(1950.019 1284.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7869",
    "data-name": "Grupo 7869",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2953",
    "data-name": "Trazado 2953",
    d: "M2457.659,1303.422a2.99,2.99,0,0,0,.027.4c.381,3.306,5.113,9.815,5.113,9.815s3.5,1.246,5.064.253c.622-.4,1.039-2.963,1.125-5.433.068-2.018-.087-3.974-.542-4.625C2467.14,1301.963,2457.662,1301.411,2457.659,1303.422Z",
    transform: "translate(-2457.659 -1302.15)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7872",
    "data-name": "Grupo 7872",
    transform: "translate(1950.045 1285.418)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7871",
    "data-name": "Grupo 7871",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2954",
    "data-name": "Trazado 2954",
    d: "M2457.905,1318.978c.381,3.306,5.113,9.815,5.113,9.815s3.5,1.246,5.064.253c.622-.4,1.04-2.964,1.124-5.434-.68.819-1.471,1.387-2.159.867-1.472-1.112-.143-4.5-3.5-5.973C2462.486,1318.038,2459.972,1318.48,2457.905,1318.978Z",
    transform: "translate(-2457.905 -1318.308)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7874",
    "data-name": "Grupo 7874",
    transform: "translate(1949.048 1283.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7873",
    "data-name": "Grupo 7873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2955",
    "data-name": "Trazado 2955",
    d: "M2451.594,1300.866a4.173,4.173,0,0,0,2.239-.54c.548-.349.9-1.092,1.178-2.484.448-2.241.74-7.431-.32-8.95-1.456-2.087-8.325-2.5-10.8-1.718-1.525.479-1.753,1.37-1.754,1.859,0,3.365,4.78,10.04,5.326,10.79l.177.243.283.1A12.034,12.034,0,0,0,2451.594,1300.866Zm-3.346-1.613h0Zm4.48-.53c-.776.415-2.647.1-3.874-.291-1.453-2.04-4.634-6.951-4.77-9.246.411-.26,1.98-.593,4.519-.389,2.639.212,4.242.846,4.495,1.208C2453.768,1290.98,2453.475,1297.62,2452.728,1298.723Zm-.028.038Z",
    transform: "translate(-2442.137 -1286.808)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7876",
    "data-name": "Grupo 7876",
    transform: "translate(1943.35 1284.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7875",
    "data-name": "Grupo 7875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2956",
    "data-name": "Trazado 2956",
    d: "M2500.575,1317.2c1.887,4.838,5.669,5.9,6.906,5.9,1.79,0,2.487-.739,5.885-1.545s.194-13.8-.778-15.679-4.122-3.318-5.919-3.626a3.907,3.907,0,0,0-.642-.063c-1.562,0-6.322,4.375-6.451,5.985A20.356,20.356,0,0,0,2500.575,1317.2Z",
    transform: "translate(-2499.479 -1302.18)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7878",
    "data-name": "Grupo 7878",
    transform: "translate(1944.447 1284.478)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7877",
    "data-name": "Grupo 7877",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2957",
    "data-name": "Trazado 2957",
    d: "M2499.479,1318.15c1.887,4.839,5.669,5.895,6.906,5.895,1.79,0,2.487-.738,5.885-1.545s.194-13.8-.778-15.679-4.122-3.318-5.919-3.626a38.789,38.789,0,0,1,3.16,11.171C2509.685,1321.191,2503.576,1320.506,2499.479,1318.15Z",
    transform: "translate(-2499.479 -1303.195)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7880",
    "data-name": "Grupo 7880",
    transform: "translate(1942.38 1283.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7879",
    "data-name": "Grupo 7879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2958",
    "data-name": "Trazado 2958",
    d: "M2492.966,1309.4a8.152,8.152,0,0,0,2.969-.633,28.376,28.376,0,0,1,3.141-.94,2.53,2.53,0,0,0,1.72-1.529c1.7-3.705-1.068-14.008-1.859-15.54-1.331-2.575-5.623-4.217-7.423-4.217-2.119,0-7.25,4.758-7.42,6.88h0c-.58,7.27,1.483,11.161,3.315,13.146A8.258,8.258,0,0,0,2492.966,1309.4Zm-1.449-20.916c1.333,0,4.814,1.465,5.693,3.166.773,1.5,3.107,11.031,1.819,13.838-.182.4-.349.436-.4.449a30.044,30.044,0,0,0-3.336,1,6.294,6.294,0,0,1-2.324.523,6.419,6.419,0,0,1-4.13-2.209c-2.25-2.437-3.22-6.472-2.806-11.672C2486.161,1292.451,2490.365,1288.549,2491.517,1288.483Zm-5.487,5.093h0Zm0,0h0Z",
    transform: "translate(-2483.993 -1286.54)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7882",
    "data-name": "Grupo 7882",
    transform: "translate(2054.963 1270.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7881",
    "data-name": "Grupo 7881",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2959",
    "data-name": "Trazado 2959",
    d: "M690.01,1093.951s3.619,6.373,9.218,6.373c2.793,0,5.6-2.764,6.675-5.482a5.48,5.48,0,0,0,.43-2.67c-.182-1.394-1.705-2.847-3.575-4.136a46.1,46.1,0,0,0-7.649-4.018Z",
    transform: "translate(-690.01 -1084.019)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7884",
    "data-name": "Grupo 7884",
    transform: "translate(2054.963 1270.845)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7883",
    "data-name": "Grupo 7883",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2960",
    "data-name": "Trazado 2960",
    d: "M697.433,1093.951s3.619,6.373,9.218,6.373c2.793,0,5.6-2.764,6.675-5.482a2.312,2.312,0,0,1-2.317-.967c-3.107-3.728-.828-5.839-.828-5.839a46.094,46.094,0,0,0-7.649-4.018Z",
    transform: "translate(-697.433 -1084.019)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7886",
    "data-name": "Grupo 7886",
    transform: "translate(2053.991 1269.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7885",
    "data-name": "Grupo 7885",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2961",
    "data-name": "Trazado 2961",
    d: "M684.577,1086.651a7.866,7.866,0,0,0,5.65-2.991c1.739-1.981,2.665-4.38,2.418-6.26-.551-4.2-9.947-8.174-11.825-8.928a.972.972,0,0,0-.724,1.8c3.941,1.584,10.309,4.989,10.623,7.378a6.819,6.819,0,0,1-1.952,4.725,6.055,6.055,0,0,1-4.189,2.329h0c-4.957,0-8.34-5.824-8.374-5.883a.972.972,0,0,0-1.689.961c.159.28,3.968,6.864,10.062,6.866Z",
    transform: "translate(-674.386 -1068.402)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7888",
    "data-name": "Grupo 7888",
    transform: "translate(2059.079 1275.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7887",
    "data-name": "Grupo 7887",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2962",
    "data-name": "Trazado 2962",
    d: "M757.441,1170.134a.487.487,0,0,0,.467-.622,2.022,2.022,0,0,1,.215-1.682c1.258-2.113,5.75-3.1,5.795-3.112a.486.486,0,0,0-.175-.955,6.789,6.789,0,0,1-6.659-3.121.486.486,0,0,0-.836.5,8.366,8.366,0,0,0,4.788,3.478,7.779,7.779,0,0,0-3.747,2.717,2.985,2.985,0,0,0-.314,2.452A.486.486,0,0,0,757.441,1170.134Z",
    transform: "translate(-756.18 -1160.405)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7890",
    "data-name": "Grupo 7890",
    transform: "translate(2003.451 1261.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7889",
    "data-name": "Grupo 7889",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2963",
    "data-name": "Trazado 2963",
    d: "M746.446,978.3a19.71,19.71,0,0,0,4.542,3.388,19.33,19.33,0,0,0,9.271,2.375q1.993,0,3.864-.17c17.911-1.576,27.547-13.714,29.614-14.79,2.208-1.151,13.694-1.232,12.82-6.595a2.631,2.631,0,0,0-.649-1.234c-2-2.346-7.751-4.576-7.462-5.876.464-2.091,6.4-7.607,7.559-10.087,2.383-5.118-1.275-8.827-3.332-6.342-3.471,4.19-7.454,6.327-13.733,11.253-2.074,1.627-6.976,5.026-9.419,6.541a49.607,49.607,0,0,1-9.784,4.817,41.194,41.194,0,0,1-16.947,2.035c-.216-.015-.435-.032-.656-.049C739.927,962.609,740.068,971.91,746.446,978.3Z",
    transform: "translate(-742.163 -938.179)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7892",
    "data-name": "Grupo 7892",
    transform: "translate(2012.277 1284.87)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7891",
    "data-name": "Grupo 7891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2964",
    "data-name": "Trazado 2964",
    d: "M745.051,1329.895a19.331,19.331,0,0,0,9.271,2.376q1.993,0,3.864-.17c17.911-1.576,27.547-13.714,29.614-14.79,2.208-1.151,13.694-1.232,12.82-6.595a2.63,2.63,0,0,0-.649-1.234c-.146.835-.8,1.729-2.667,2.281-4.285,1.268-10.5,1.2-12.358,2.21-2.458,1.334-11.6,12.2-23.089,12.2a11.125,11.125,0,0,1-10.2-6.055Z",
    transform: "translate(-745.051 -1309.482)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7894",
    "data-name": "Grupo 7894",
    transform: "translate(2002.49 1260.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7893",
    "data-name": "Grupo 7893",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2965",
    "data-name": "Trazado 2965",
    d: "M745.634,970.35c1.335,0,2.664-.059,3.951-.174,14.848-1.307,24.2-9.772,28.19-13.387a16.378,16.378,0,0,1,1.785-1.508,16.828,16.828,0,0,1,3.1-.726c4.391-.806,11.026-2.025,10.233-6.887-.318-1.953-2.876-3.517-5.35-5.03a16.416,16.416,0,0,1-2.719-1.881c.371-.978,2.175-3.059,3.641-4.75a28.182,28.182,0,0,0,3.8-4.968c1.708-3.669.669-6.887-1.175-8.053a2.787,2.787,0,0,0-3.786.681c-2.3,2.776-4.8,4.594-8.249,7.11-1.567,1.142-3.343,2.435-5.335,4s-6.891,4.966-9.332,6.48a48.839,48.839,0,0,1-9.593,4.725,40.309,40.309,0,0,1-16.56,1.983c-.2-.013-.4-.029-.6-.044l-.048,0c-7.147-.561-9.591,2.338-10.412,4.116-1.567,3.4.025,8.327,3.961,12.271h0A20.642,20.642,0,0,0,745.634,970.35Zm43.919-45.885a.926.926,0,0,1,.495.162c.98.62,1.768,2.763.452,5.59a28.589,28.589,0,0,1-3.505,4.516c-2.376,2.741-3.839,4.5-4.121,5.771-.305,1.37,1.27,2.333,3.654,3.791,1.7,1.04,4.271,2.612,4.446,3.685.449,2.752-4.035,3.813-8.667,4.664a15.478,15.478,0,0,0-3.643.913,13.576,13.576,0,0,0-2.191,1.791c-3.848,3.484-12.858,11.642-27.058,12.892-1.231.11-2.5.166-3.779.166a18.685,18.685,0,0,1-13.126-5.479h0c-3.364-3.371-4.8-7.423-3.572-10.084,1.051-2.278,4.069-3.34,8.5-2.993l.05,0c.208.016.413.032.617.046a42.2,42.2,0,0,0,17.333-2.088,50.743,50.743,0,0,0,9.975-4.908c2.533-1.571,7.42-4.965,9.507-6.6,1.965-1.541,3.726-2.825,5.28-3.957,3.434-2.5,6.147-4.478,8.6-7.441A1.006,1.006,0,0,1,789.552,924.465Z",
    transform: "translate(-726.575 -922.52)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7896",
    "data-name": "Grupo 7896",
    transform: "translate(2033.325 1282.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7895",
    "data-name": "Grupo 7895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2966",
    "data-name": "Trazado 2966",
    d: "M1188.521,1298.695a.972.972,0,0,0,.638-1.7c-6.174-5.364-5.01-18.832-5-18.967a.972.972,0,0,0-1.935-.179c-.055.593-1.27,14.595,5.658,20.613A.968.968,0,0,0,1188.521,1298.695Z",
    transform: "translate(-1182.111 -1276.962)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7898",
    "data-name": "Grupo 7898",
    transform: "translate(1981.125 1279.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7897",
    "data-name": "Grupo 7897",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2967",
    "data-name": "Trazado 2967",
    d: "M1355.861,1271.339c9.959,1.635,38.727,3.685,39.929-1.241.359-1.482-1.368-12.239-5.023-23.5a101.063,101.063,0,0,0-4.239-10.976,59.54,59.54,0,0,0-3.5-6.57,11.419,11.419,0,0,0-3.59-2.73c-9.825-5.64-35.29-14.047-31.622-1.436a30.534,30.534,0,0,1,.95,4.588,39.754,39.754,0,0,1,.33,5.373,105.5,105.5,0,0,1-1.661,15.591C1345.817,1261.079,1344.986,1269.554,1355.861,1271.339Z",
    transform: "translate(-1346.48 -1218.311)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7900",
    "data-name": "Grupo 7900",
    transform: "translate(1980.114 1298.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7899",
    "data-name": "Grupo 7899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2968",
    "data-name": "Trazado 2968",
    d: "M1332.894,1536.939c-1,4.438-1.786,8.881-2.381,13.453q-.222,1.712-.336,3.46a27.505,27.505,0,0,0-.019,3.537,15.829,15.829,0,0,0,.608,3.593,9.933,9.933,0,0,0,1.738,3.364,9.469,9.469,0,0,0,2.939,2.415,14.57,14.57,0,0,0,3.448,1.29c.293.075.588.122.883.184s.592.12.874.161q.857.137,1.71.255,1.708.236,3.415.425,3.415.383,6.836.638t6.854.387c2.288.082,4.58.122,6.877.094s4.6-.118,6.914-.361a31.671,31.671,0,0,0,3.488-.545,15.138,15.138,0,0,0,1.765-.5,6.86,6.86,0,0,0,1.795-.913,3.34,3.34,0,0,0,.841-.915c.056-.1.115-.206.162-.317s.082-.234.117-.351.042-.238.058-.358l.015-.274a14.378,14.378,0,0,0-.1-1.845c-.125-1.169-.3-2.307-.5-3.443-.393-2.269-.867-4.512-1.391-6.744s-1.1-4.45-1.751-6.647a80.205,80.205,0,0,0-4.914-12.828.487.487,0,0,0-.9.373v0q2.19,6.441,3.98,12.974c1.188,4.358,2.244,8.767,2.988,13.207.183,1.108.349,2.22.458,3.315a12.833,12.833,0,0,1,.085,1.561l-.008.152a.246.246,0,0,0-.008.063.135.135,0,0,0-.02.053c-.009.019-.026.039-.034.061a1.356,1.356,0,0,1-.317.323,4.935,4.935,0,0,1-1.247.607,13.193,13.193,0,0,1-1.522.417,29.63,29.63,0,0,1-3.257.487c-2.214.219-4.466.293-6.718.309s-4.514-.04-6.773-.134c-4.518-.2-9.042-.509-13.537-1q-1.685-.183-3.36-.408-.837-.113-1.666-.243c-.281-.041-.541-.1-.8-.146s-.531-.1-.788-.161a9.439,9.439,0,0,1-5.256-2.941,10.061,10.061,0,0,1-1.941-5.775,36.122,36.122,0,0,1,.286-6.621c.255-2.233.627-4.474.918-6.734a49.6,49.6,0,0,0,.462-6.857.489.489,0,0,0-.966-.1Z",
    transform: "translate(-1330.11 -1533.887)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7903",
    "data-name": "Grupo 7903",
    transform: "translate(2008.547 1276.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7902",
    "data-name": "Grupo 7902",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7901",
    "data-name": "Grupo 7901"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2969",
    "data-name": "Trazado 2969",
    d: "M1692.7,1176.388c.119-.112.242-.227.371-.342l-.4.235Z",
    transform: "translate(-1692.676 -1176.046)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7947",
    "data-name": "Grupo 7947",
    transform: "translate(1965.831 1230.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7946",
    "data-name": "Grupo 7946",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7905",
    "data-name": "Grupo 7905",
    transform: "translate(4.592 0.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7904",
    "data-name": "Grupo 7904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2970",
    "data-name": "Trazado 2970",
    d: "M1320.246,497.613c-17.756,40.171-74.41,17.508-61.573-22.794C1275.873,433.268,1334.413,456.749,1320.246,497.613Z",
    transform: "translate(-1256.797 -452.992)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7907",
    "data-name": "Grupo 7907",
    transform: "translate(4.592 0.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7906",
    "data-name": "Grupo 7906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2971",
    "data-name": "Trazado 2971",
    d: "M1320.246,497.613c-17.756,40.171-74.41,17.508-61.573-22.794C1275.873,433.268,1334.413,456.749,1320.246,497.613Z",
    transform: "translate(-1256.797 -452.992)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7909",
    "data-name": "Grupo 7909",
    transform: "translate(13.864 48.584)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7908",
    "data-name": "Grupo 7908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2972",
    "data-name": "Trazado 2972",
    d: "M1337.739,1231.391a32.63,32.63,0,0,0,4.042,3.459q1.217.889,2.509,1.657a33.307,33.307,0,0,0,21.489,4.5,29.85,29.85,0,0,0,13.439-5.383,34.373,34.373,0,0,0,9.852-11.336,41.2,41.2,0,0,1-16.947,2.035c-9.825-5.64-35.29-14.047-31.622-1.436a30.534,30.534,0,0,1,.95,4.588C1340.418,1230.074,1339.165,1230.74,1337.739,1231.391Z",
    transform: "translate(-1337.739 -1218.311)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7911",
    "data-name": "Grupo 7911",
    transform: "translate(4.592 0.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7910",
    "data-name": "Grupo 7910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2973",
    "data-name": "Trazado 2973",
    d: "M1320.246,497.613c-17.756,40.171-74.41,17.508-61.573-22.794C1275.873,433.268,1334.413,456.749,1320.246,497.613Z",
    transform: "translate(-1256.797 -452.992)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7913",
    "data-name": "Grupo 7913",
    transform: "translate(3.898 0.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7912",
    "data-name": "Grupo 7912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2974",
    "data-name": "Trazado 2974",
    d: "M1279.7,508.838a32,32,0,0,0,11.475-2.1c8.392-3.22,15.039-9.925,19.222-19.389l.021-.053c3.367-9.711,2.916-19.139-1.3-27.264a34.034,34.034,0,0,0-18.281-15.971,33.352,33.352,0,0,0-24.105-.113c-8.5,3.348-15.13,10.286-19.177,20.064l-.02.055c-3.055,9.591-2.434,18.866,1.8,26.823a33.97,33.97,0,0,0,18.088,15.668A34.685,34.685,0,0,0,1279.7,508.838Zm29.419-22.024c-8.921,20.151-27.124,23.785-41.213,18.446-13.765-5.217-25.6-20.191-19.064-40.748,8.6-20.73,27.536-24.464,41.5-19.158C1304.443,450.713,1316.33,465.97,1309.118,486.814Z",
    transform: "translate(-1245.621 -441.748)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7915",
    "data-name": "Grupo 7915",
    transform: "translate(4.581 24.355)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7914",
    "data-name": "Grupo 7914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2975",
    "data-name": "Trazado 2975",
    d: "M1320.237,850.034c-14.732,34.963-64.19,23.355-63.45-13.1,3.568,11.344,7.635,11.322,14.474,16.489,21.141,17.112,48.9-.723,49.778-24.629A32.836,32.836,0,0,1,1320.237,850.034Z",
    transform: "translate(-1256.779 -828.791)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7917",
    "data-name": "Grupo 7917",
    transform: "translate(3.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7916",
    "data-name": "Grupo 7916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2976",
    "data-name": "Trazado 2976",
    d: "M1275.487,504.91a32.271,32.271,0,0,0,11.575-2.12c8.463-3.247,15.163-10,19.377-19.537l.03-.074c3.392-9.785,2.936-19.289-1.319-27.484a34.313,34.313,0,0,0-18.43-16.1,33.628,33.628,0,0,0-24.307-.112c-8.571,3.377-15.256,10.367-19.333,20.216l-.028.077c-3.078,9.664-2.45,19.014,1.816,27.039a34.25,34.25,0,0,0,18.235,15.8A34.964,34.964,0,0,0,1275.487,504.91Zm29.159-22.4c-8.849,19.974-26.891,23.579-40.854,18.287-13.643-5.171-25.372-20.013-18.9-40.391,8.527-20.549,27.3-24.252,41.138-18.993C1300.007,446.719,1311.789,461.843,1304.646,482.505Z",
    transform: "translate(-1241.129 -437.262)",
    fill: "#293856"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7919",
    "data-name": "Grupo 7919",
    transform: "translate(3.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7918",
    "data-name": "Grupo 7918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2977",
    "data-name": "Trazado 2977",
    d: "M1275.487,504.91a32.271,32.271,0,0,0,11.575-2.12c8.463-3.247,15.163-10,19.377-19.537l.03-.074c3.392-9.785,2.936-19.289-1.319-27.484a34.313,34.313,0,0,0-18.43-16.1,33.628,33.628,0,0,0-24.307-.112c-8.571,3.377-15.256,10.367-19.333,20.216l-.028.077c-3.078,9.664-2.45,19.014,1.816,27.039a34.25,34.25,0,0,0,18.235,15.8A34.964,34.964,0,0,0,1275.487,504.91Zm29.159-22.4c-8.849,19.974-26.891,23.579-40.854,18.287-13.643-5.171-25.372-20.013-18.9-40.391,8.527-20.549,27.3-24.252,41.138-18.993C1300.007,446.719,1311.789,461.843,1304.646,482.505Z",
    transform: "translate(-1241.129 -437.262)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7921",
    "data-name": "Grupo 7921",
    transform: "translate(14.697 7.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7920",
    "data-name": "Grupo 7920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2978",
    "data-name": "Trazado 2978",
    d: "M1306.185,597.7c-29.23,25.15-63.821-8.017-42.995-34.589C1288.326,534.768,1327.646,564.869,1306.185,597.7Z",
    transform: "translate(-1256.837 -551.827)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7923",
    "data-name": "Grupo 7923",
    transform: "translate(15.601 28.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7922",
    "data-name": "Grupo 7922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2979",
    "data-name": "Trazado 2979",
    d: "M1324.7,902.791c6.3,34.279-42.252,45.935-53.151,15.54C1290.583,933.977,1318.486,921.039,1324.7,902.791Z",
    transform: "translate(-1271.552 -902.791)",
    fill: "#21102b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7925",
    "data-name": "Grupo 7925",
    transform: "translate(10.386 2.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7924",
    "data-name": "Grupo 7924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2980",
    "data-name": "Trazado 2980",
    d: "M1272.915,546.7a27.9,27.9,0,0,0,11.74-2.545c6.964-3.225,12.469-9.361,15.922-17.745l0-.007c5.609-13.922.6-34.08-15.8-41.9l-.154-.058A34.624,34.624,0,0,0,1242.6,509.8a30.627,30.627,0,0,0,4.485,23.046,31.526,31.526,0,0,0,17.3,12.613A30.257,30.257,0,0,0,1272.915,546.7Zm25.863-21.028c-7.557,18.348-22.953,21.123-33.842,17.924-12.518-3.678-23.554-16.339-20.428-33.421a32.692,32.692,0,0,1,39.505-23.88C1299.368,493.664,1304.046,512.586,1298.778,525.669Z",
    transform: "translate(-1242.024 -483.301)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7927",
    "data-name": "Grupo 7927",
    transform: "translate(13.725 6.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7926",
    "data-name": "Grupo 7926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2981",
    "data-name": "Trazado 2981",
    d: "M1269.5,592.968c7.85,0,15.67-3.164,22.658-9.177l.1-.09.075-.115c5.17-7.909,7.239-16.251,5.986-24.125a27.553,27.553,0,0,0-10.527-17.643,27.047,27.047,0,0,0-19.222-5.471c-7.624.779-14.807,4.746-20.773,11.474l-.038.045c-4.876,6.221-7.105,13.213-6.447,20.221a27.01,27.01,0,0,0,8.356,16.94,28.621,28.621,0,0,0,19.179,7.935Q1269.176,592.968,1269.5,592.968Zm21.286-10.561c-14.957,12.793-30.743,9.837-39.77,1.213-8.194-7.828-11.907-21.539-1.74-34.534,12.516-14.095,27.771-13.034,37.341-5.726C1296.134,550.629,1301.481,565.936,1290.786,582.407Z",
    transform: "translate(-1241.204 -536.206)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7929",
    "data-name": "Grupo 7929",
    transform: "translate(1.362 33.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7928",
    "data-name": "Grupo 7928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2982",
    "data-name": "Trazado 2982",
    d: "M2078.182,991.633c4.773,14.732,19.94,11.188,16.8-3.336C2090.547,972.673,2074.334,976.46,2078.182,991.633Z",
    transform: "translate(-2077.597 -978.263)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7931",
    "data-name": "Grupo 7931",
    transform: "translate(1.748 37.226)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7930",
    "data-name": "Grupo 7930",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2983",
    "data-name": "Trazado 2983",
    d: "M2089,1054.821c4.554-1.029,6.947-7.2,5.058-13.406-1.765,7.133-10.6-2.649-11.626-5.708C2071.133,1040.683,2080.677,1056.89,2089,1054.821Z",
    transform: "translate(-2077.263 -1035.707)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7933",
    "data-name": "Grupo 7933",
    transform: "translate(0.391 32.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7932",
    "data-name": "Grupo 7932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2984",
    "data-name": "Trazado 2984",
    d: "M2073.359,987.486a7.646,7.646,0,0,0,1.99-.26c4.122-1.11,7.515-5.778,5.8-13.7l-.015-.06c-2.42-8.524-8.381-11.722-13.019-10.476-4.189,1.125-7.746,6.085-5.658,14.315l.018.061C2064.8,984.541,2069.4,987.486,2073.359,987.486Zm5.9-13.522c1.429,6.658-1.186,10.516-4.415,11.386-3.422.923-8.168-1.363-10.509-8.555-1.748-6.936.994-11.046,4.286-11.931C2072.335,963.866,2077.177,966.673,2079.259,973.965Zm-15.858,3.1h0Z",
    transform: "translate(-2061.844 -962.729)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7935",
    "data-name": "Grupo 7935",
    transform: "translate(0.968 37.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7934",
    "data-name": "Grupo 7934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2985",
    "data-name": "Trazado 2985",
    d: "M2151.455,1047.2c3.88,11.935,15.288,9.471,12.751-2.276C2160.63,1032.108,2148.236,1034.8,2151.455,1047.2Z",
    transform: "translate(-2150.926 -1036.516)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7937",
    "data-name": "Grupo 7937",
    transform: "translate(0 36.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7936",
    "data-name": "Grupo 7936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2986",
    "data-name": "Trazado 2986",
    d: "M2144.627,1041.4a5.64,5.64,0,0,0,1.472-.192c3.173-.856,5.749-4.617,4.351-11.089l-.014-.056c-2-7.164-6.756-9.913-10.422-8.926-3.261.878-5.967,4.916-4.2,11.708l.016.056C2137.783,1038.92,2141.494,1041.4,2144.627,1041.4Zm3.93-10.843c1.116,5.208-.682,8.159-2.964,8.775-2.491.672-6.025-1.234-7.91-7-1.416-5.494.475-8.679,2.836-9.315C2143.258,1022.275,2146.9,1024.631,2148.557,1030.557Zm-11.807,2.043h0Z",
    transform: "translate(-2135.254 -1020.943)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7939",
    "data-name": "Grupo 7939",
    transform: "translate(20.154 30.193)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7938",
    "data-name": "Grupo 7938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2987",
    "data-name": "Trazado 2987",
    d: "M1923.24,929.056c2.783,5.9,9.533,2.837,7.986-2.665C1928.885,919.562,1920.871,923.039,1923.24,929.056Z",
    transform: "translate(-1922.807 -922.643)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7941",
    "data-name": "Grupo 7941",
    transform: "translate(25.741 42.979)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7940",
    "data-name": "Grupo 7940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2988",
    "data-name": "Trazado 2988",
    d: "M1915.053,1130.917c1.194,2.193,4.172.913,3.1-1.591C1916.954,1127.133,1913.976,1128.414,1915.053,1130.917Z",
    transform: "translate(-1914.822 -1128.203)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7943",
    "data-name": "Grupo 7943",
    transform: "translate(34.448 11.241)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7942",
    "data-name": "Grupo 7942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2989",
    "data-name": "Trazado 2989",
    d: "M1373.4,638.242c.217-23.519-24-22.7-30.419-16.694C1358.362,620.164,1366.6,628.485,1373.4,638.242Z",
    transform: "translate(-1342.978 -617.967)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7945",
    "data-name": "Grupo 7945",
    transform: "translate(1.183 43.302)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7944",
    "data-name": "Grupo 7944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2990",
    "data-name": "Trazado 2990",
    d: "M2153.836,1138.449a11.124,11.124,0,0,0-1.467-5.065c-.858,8.632-9.775,6.313-12.659.68C2139.833,1146.609,2153.2,1150.338,2153.836,1138.449Z",
    transform: "translate(-2139.71 -1133.384)",
    fill: "#371a45"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7949",
    "data-name": "Grupo 7949",
    transform: "translate(1960.763 1312.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7948",
    "data-name": "Grupo 7948",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2991",
    "data-name": "Trazado 2991",
    d: "M1110.2,1803.941c4.787.751,13.2-1.2,16.24-8.146,0,0,3.529-12.346,11.7-20.415,6.029-5.956,19.125-7.323,21.945-3.25,2.723,3.93-2.844,14.586.539,20.262,1.346,2.254,9.587,6.184,20.779,4.537,4.676-.69,5.37-4.156,4.892-6.461a5.5,5.5,0,0,0-.138-.542c-1.37-4.416-7.525-5.419-7.525-5.419s8-11.61,4.97-21.219c-2.538-8.037-8.965-11.071-14.131-11.115a9.562,9.562,0,0,0-5.8,1.618l-25.37-4.586-15.579-2.818c-.255,2.548-.6,4.931-1.018,7.219-.408,2.22-.894,4.35-1.46,6.459-2.329,8.666-6,16.937-11.069,29.3-4.474,2.81-6.913,5.436-7.544,7.683C1100.684,1800.422,1103.8,1802.938,1110.2,1803.941Z",
    transform: "translate(-1101.464 -1746.388)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7951",
    "data-name": "Grupo 7951",
    transform: "translate(1960.763 1314.864)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7950",
    "data-name": "Grupo 7950",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2992",
    "data-name": "Trazado 2992",
    d: "M1110.2,1846.419c4.787.75,13.2-1.2,16.24-8.147,0,0,3.529-12.346,11.7-20.415,6.029-5.956,19.125-7.323,21.945-3.25,2.723,3.93-2.844,14.586.539,20.262,1.346,2.254,9.587,6.184,20.779,4.537,4.676-.69,5.37-4.156,4.892-6.461-1.384.882-4.049,1.652-9.164,1.487-11.12-.357-14.719-3.539-13-12.021,1.6-7.9,1.149-13.4-1.933-15.975l.578-.07a.022.022,0,0,1,.012,0l.282-.034a3.95,3.95,0,0,0,.416-.073c.056-.012.112-.029.165-.044s.131-.034.194-.054h-.007a4.248,4.248,0,0,0,2.932-4.54l-.1-.872c0-.561-.015-1.12-.046-1.681a3.771,3.771,0,0,0,2.932-3.826c-.007-.138-.022-.277-.041-.41,0-.029-.012-.056-.017-.083s-.012-.066-.017-.1a9.562,9.562,0,0,0-5.8,1.617l-25.37-4.586a4.154,4.154,0,0,0-.27.444c-.017.032-.029.063-.044.092-.044.085-.083.17-.119.26-.017.041-.032.083-.049.124-.029.08-.056.16-.083.24-.015.049-.027.095-.039.141-.022.08-.041.16-.058.243-.01.049-.019.095-.027.146-.015.083-.027.167-.034.253,0,.049-.012.095-.015.141-.007.095-.01.192-.01.287,0,.039,0,.078,0,.114a3.9,3.9,0,0,0,.029.411l.214,1.8c-2.133.391-10.724,1.763-16.092-.289-.408,2.22-.894,4.35-1.46,6.458a2.47,2.47,0,0,0,.432.333s7.066,3.024,17.911.1l.24,1.994a4.067,4.067,0,0,0,.206.884.034.034,0,0,1,0,.015c.049.134.1.265.16.391l.022.044c.058.117.119.228.185.34l.007.015c.019.029.039.056.056.085.068.1.138.2.214.3.031.041.066.085.1.126s.083.095.124.141.083.087.126.131.08.08.121.119c.075.07.153.139.233.2l.032.029c.029.022.058.039.085.061.063.046.124.09.189.134.044.029.085.056.129.083.063.039.129.075.194.112.041.022.08.046.124.066.1.051.2.1.3.138.044.02.09.034.134.051l.109.036a18.9,18.9,0,0,0-6.2,3.826c-7.52,7.884-9.279,18.627-13.92,26.147-2.432,3.937-14.545,5.2-19.929,1.081C1100.684,1842.9,1103.8,1845.416,1110.2,1846.419Z",
    transform: "translate(-1101.464 -1791.683)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7953",
    "data-name": "Grupo 7953",
    transform: "translate(1959.792 1311.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7952",
    "data-name": "Grupo 7952",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2993",
    "data-name": "Trazado 2993",
    d: "M1097.612,1790.411c5.227,0,12.254-2.473,15.059-8.882l.044-.122c.035-.121,3.56-12.2,11.443-19.989,4.038-3.989,11.228-5.674,15.941-5.237,2.237.208,3.844.864,4.525,1.847,1.053,1.52.531,4.691-.021,8.048-.682,4.144-1.455,8.839.525,12.16,1.613,2.706,10.261,6.691,21.754,5a6.182,6.182,0,0,0,5.541-8.252c-1.113-3.582-4.839-5.149-6.9-5.756,1.978-3.264,6.944-12.649,4.344-20.886-2.362-7.484-7.654-10.156-10.6-11.082-3.994-1.257-8.356-.812-10.853,1.108a.972.972,0,1,0,1.184,1.541c1.985-1.526,5.721-1.853,9.085-.795,2.583.813,7.23,3.168,9.328,9.813,2.853,9.038-4.765,20.263-4.842,20.375l-.869,1.263,1.512.247c.054.009,5.58.969,6.755,4.748a4.694,4.694,0,0,1-.385,3.766,4.8,4.8,0,0,1-3.584,1.987c-11.062,1.629-18.747-2.3-19.8-4.071-1.616-2.711-.935-6.848-.277-10.849.618-3.757,1.2-7.3-.3-9.471-1.028-1.484-3.083-2.409-5.942-2.675-5.15-.48-13.03,1.386-17.486,5.789-8.033,7.936-11.606,19.677-11.926,20.772-2.806,6.313-10.7,8.222-15.175,7.521-4.594-.72-7.461-2.267-7.867-4.244-.465-2.263,2.161-5.378,7.2-8.547l.264-.166.118-.288c.824-2.01,1.611-3.913,2.362-5.726,6.159-14.883,9.878-23.865,11.252-37.526a.972.972,0,1,0-1.933-.195c-1.346,13.377-5.023,22.26-11.114,36.978-.715,1.729-1.464,3.538-2.247,5.445-7.261,4.632-8.261,8.216-7.809,10.416.415,2.021,2.4,4.663,9.47,5.773A14.414,14.414,0,0,0,1097.612,1790.411Z",
    transform: "translate(-1085.829 -1730.762)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7955",
    "data-name": "Grupo 7955",
    transform: "translate(1982.29 1307.373)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7954",
    "data-name": "Grupo 7954",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2994",
    "data-name": "Trazado 2994",
    d: "M2121.218,1671.25",
    transform: "translate(-2121.218 -1671.25)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 29.664
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7957",
    "data-name": "Grupo 7957",
    transform: "translate(2020.738 1310.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7956",
    "data-name": "Grupo 7956",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_282",
    "data-name": "Elipse 282",
    cx: 3.761,
    cy: 3.761,
    r: 3.761,
    transform: "translate(5.319 10.639) rotate(-135)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7959",
    "data-name": "Grupo 7959",
    transform: "translate(2022.295 1313.673)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7958",
    "data-name": "Grupo 7958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2995",
    "data-name": "Trazado 2995",
    d: "M1364.678,1774.131a3.762,3.762,0,1,1-7.517.316,3.722,3.722,0,0,1,.294-1.622,3.762,3.762,0,0,0,6.794-.286A3.718,3.718,0,0,1,1364.678,1774.131Z",
    transform: "translate(-1357.158 -1772.54)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7961",
    "data-name": "Grupo 7961",
    transform: "translate(2021.529 1310.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7960",
    "data-name": "Grupo 7960",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2996",
    "data-name": "Trazado 2996",
    d: "M1349.348,1736.936q.1,0,.195,0a4.518,4.518,0,1,0-.195,0Zm.006-7.523a3,3,0,0,1,2.991,2.869h0a2.995,2.995,0,1,1-3.118-2.867Zm3.756,2.837h0Z",
    transform: "translate(-1344.825 -1727.88)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7963",
    "data-name": "Grupo 7963",
    transform: "translate(2025.077 1307.283)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7962",
    "data-name": "Grupo 7962",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2997",
    "data-name": "Trazado 2997",
    d: "M1404.893,1681.366a57.746,57.746,0,0,1-1.375-11.556,58.481,58.481,0,0,0,1.041,6.268,33.2,33.2,0,0,1,.809,7.879C1405.242,1683.084,1405.081,1682.218,1404.893,1681.366Z",
    transform: "translate(-1403.518 -1669.81)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7965",
    "data-name": "Grupo 7965",
    transform: "translate(1997.82 1307.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7964",
    "data-name": "Grupo 7964",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2998",
    "data-name": "Trazado 2998",
    d: "M1426.922,1692.454l-19.528,2.343a4.247,4.247,0,0,1-4.709-3.7l-1.246-10.392a4.25,4.25,0,0,1,2.871-4.523,4.127,4.127,0,0,1,.83-.186l19.526-2.342a4.244,4.244,0,0,1,4.709,3.7l.989,8.231.26,2.161A4.247,4.247,0,0,1,1426.922,1692.454Z",
    transform: "translate(-1401.409 -1673.622)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7967",
    "data-name": "Grupo 7967",
    transform: "translate(1997.821 1310.079)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7966",
    "data-name": "Grupo 7966",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2999",
    "data-name": "Trazado 2999",
    d: "M1426.917,1731.032l-19.529,2.343a4.247,4.247,0,0,1-4.709-3.7l-1.246-10.392a4.25,4.25,0,0,1,2.871-4.523c1.2.6,1.958.99,1.958.99,1.951,8.227,4.826,12.1,15.2,11.029,4.48-.465,7.221-1.485,8.891-2.616l.26,2.161A4.248,4.248,0,0,1,1426.917,1731.032Z",
    transform: "translate(-1401.403 -1714.759)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7969",
    "data-name": "Grupo 7969",
    transform: "translate(1997.087 1306.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7968",
    "data-name": "Grupo 7968",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3000",
    "data-name": "Trazado 3000",
    d: "M1396.088,1684.485a5.348,5.348,0,0,0,.635-.038l18.942-2.273a5.3,5.3,0,0,0,4.627-5.889l-1.177-9.809a5.309,5.309,0,0,0-5.889-4.627l-18.942,2.273a5.309,5.309,0,0,0-4.627,5.889l1.177,9.809A5.3,5.3,0,0,0,1396.088,1684.485Zm.452-1.56a3.767,3.767,0,0,1-4.184-3.288l-1.177-9.809a3.776,3.776,0,0,1,3.288-4.185l18.942-2.273a3.776,3.776,0,0,1,4.185,3.288l1.177,9.809a3.767,3.767,0,0,1-3.288,4.185Z",
    transform: "translate(-1389.619 -1661.81)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7971",
    "data-name": "Grupo 7971",
    transform: "translate(1997.821 1309.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7970",
    "data-name": "Grupo 7970",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3001",
    "data-name": "Trazado 3001",
    d: "M1475.221,1720.44a3.768,3.768,0,0,1-.774.171l-19.528,2.343a4.243,4.243,0,0,1-4.122-2.012,4.166,4.166,0,0,1-.584-1.689l-.556-4.617-.183-1.523-.51-4.252a4.248,4.248,0,0,1,3.7-4.709l4.22-.505a4.247,4.247,0,0,0-2.932,4.539l.672,5.614.574,4.781a4.249,4.249,0,0,0,4.709,3.7Z",
    transform: "translate(-1448.932 -1703.646)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7973",
    "data-name": "Grupo 7973",
    transform: "translate(1998.361 1318.855)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7972",
    "data-name": "Grupo 7972",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3002",
    "data-name": "Trazado 3002",
    d: "M1474.68,1863.159a3.752,3.752,0,0,1-.774.171l-19.528,2.343a4.243,4.243,0,0,1-4.707-3.7l-.739-6.14c.621,1.026,1.663,2.252,3.092,2.222a2.838,2.838,0,0,0,2.058-1.536l.574,4.781a4.249,4.249,0,0,0,4.709,3.7Z",
    transform: "translate(-1448.932 -1855.832)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7975",
    "data-name": "Grupo 7975",
    transform: "translate(1997.054 1308.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7974",
    "data-name": "Grupo 7974",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3003",
    "data-name": "Trazado 3003",
    d: "M1451.315,1712.258a5.023,5.023,0,0,0,.6-.036l19.528-2.344a4.687,4.687,0,0,0,.923-.2l-.33-1.489-15.316,1.839a3.479,3.479,0,0,1-3.855-3.031l-1.247-10.394a3.472,3.472,0,0,1,2.4-3.719l-.322-1.491-4.218.505a5.008,5.008,0,0,0-4.37,5.563l1.247,10.392a5.015,5.015,0,0,0,4.958,4.407Zm1.92-1.738-1.5.18a3.48,3.48,0,0,1-3.855-3.031h0l-1.247-10.393a3.473,3.473,0,0,1,3.031-3.858l1.353-.162a4.991,4.991,0,0,0-.918,3.528l1.247,10.393a4.964,4.964,0,0,0,1.878,3.333Z",
    transform: "translate(-1445.074 -1691.391)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7977",
    "data-name": "Grupo 7977",
    transform: "translate(2005.68 1314.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7976",
    "data-name": "Grupo 7976",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3004",
    "data-name": "Trazado 3004",
    d: "M1662.287,1795c.044.385-.142,3.551-.142,3.551l-2.191.25c-1.509.172-2.91-1.25-3.13-3.177s.825-3.628,2.333-3.8l2.191-.25S1662.215,1794.378,1662.287,1795Z",
    transform: "translate(-1656.794 -1791.577)",
    fill: "#22a7f0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7979",
    "data-name": "Grupo 7979",
    transform: "translate(2005.68 1314.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7978",
    "data-name": "Grupo 7978",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3005",
    "data-name": "Trazado 3005",
    d: "M1662.287,1795c.044.385-.142,3.551-.142,3.551l-2.191.25c-1.509.172-2.91-1.25-3.13-3.177s.825-3.628,2.333-3.8l2.191-.25S1662.215,1794.378,1662.287,1795Z",
    transform: "translate(-1656.794 -1791.577)",
    fill: "#127ddd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7981",
    "data-name": "Grupo 7981",
    transform: "translate(2005.067 1314.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7980",
    "data-name": "Grupo 7980",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3006",
    "data-name": "Trazado 3006",
    d: "M1650.467,1791.245a2.778,2.778,0,0,0,.314-.018l1.522-.174a1.408,1.408,0,0,0,1.25-1.325,26.03,26.03,0,0,0,.1-2.981,25.1,25.1,0,0,0-.767-2.9,1.41,1.41,0,0,0-1.512-1l-1.53.175c-1.842.21-3.131,2.22-2.873,4.479C1647.216,1789.641,1648.749,1791.245,1650.467,1791.245Zm1.969-4.36c.012.144-.008.956-.107,2.777a.185.185,0,0,1-.165.173l-1.522.174c-1.174.133-2.27-1.05-2.451-2.637s.624-2.989,1.794-3.122l1.53-.175a.187.187,0,0,1,.2.131A22.981,22.981,0,0,1,1652.436,1786.885Zm.609-.068h0Z",
    transform: "translate(-1646.939 -1782.847)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7983",
    "data-name": "Grupo 7983",
    transform: "translate(2007.502 1314.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7982",
    "data-name": "Grupo 7982",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_283",
    "data-name": "Elipse 283",
    cx: 3.512,
    cy: 2.749,
    rx: 3.512,
    ry: 2.749,
    transform: "translate(0.797 7.602) rotate(-96.513)",
    fill: "#22a7f0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7985",
    "data-name": "Grupo 7985",
    transform: "translate(2007.87 1314.844)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7984",
    "data-name": "Grupo 7984",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3007",
    "data-name": "Trazado 3007",
    d: "M1626.728,1795.275a2.693,2.693,0,1,0-5.347.62,4.5,4.5,0,0,1-.141-.72c-.218-1.927.827-3.629,2.336-3.8s2.909,1.249,3.13,3.176A4.357,4.357,0,0,1,1626.728,1795.275Z",
    transform: "translate(-1621.211 -1791.361)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7987",
    "data-name": "Grupo 7987",
    transform: "translate(2007.87 1316.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7986",
    "data-name": "Grupo 7986",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3008",
    "data-name": "Trazado 3008",
    d: "M1624.362,1827.9c-1.508.174-2.911-1.249-3.132-3.176a4.411,4.411,0,0,1,.04-1.277,2.589,2.589,0,0,0,5.1-.578,4.286,4.286,0,0,1,.326,1.23C1626.915,1826.023,1625.87,1827.724,1624.362,1827.9Z",
    transform: "translate(-1621.201 -1822.865)",
    fill: "#127ddd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7989",
    "data-name": "Grupo 7989",
    transform: "translate(2007.258 1314.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7988",
    "data-name": "Grupo 7988",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3009",
    "data-name": "Trazado 3009",
    d: "M1614.885,1789.729a2.748,2.748,0,0,0,.314-.018c1.842-.21,3.131-2.22,2.873-4.48h0c-.258-2.26-1.966-3.927-3.809-3.717s-3.131,2.22-2.873,4.479C1611.634,1788.125,1613.167,1789.729,1614.885,1789.729Zm1.969-4.359c.181,1.588-.623,2.989-1.794,3.122s-2.27-1.05-2.451-2.638.624-2.989,1.794-3.122,2.27,1.05,2.452,2.637Z",
    transform: "translate(-1611.358 -1781.496)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7991",
    "data-name": "Grupo 7991",
    transform: "translate(2016.119 1307.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7990",
    "data-name": "Grupo 7990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3010",
    "data-name": "Trazado 3010",
    d: "M1515.2,1689.584l.059,0a.613.613,0,0,0,.552-.669l-.506-5.272a3.038,3.038,0,0,1,1.115-2.658,4.25,4.25,0,0,0,1.555-3.814l-.864-7.415a.613.613,0,1,0-1.218.142l.864,7.415a3.031,3.031,0,0,1-1.109,2.719,4.263,4.263,0,0,0-1.564,3.728l.506,5.272A.614.614,0,0,0,1515.2,1689.584Z",
    transform: "translate(-1514.063 -1669.211)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7993",
    "data-name": "Grupo 7993",
    transform: "translate(1979.18 1315.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7992",
    "data-name": "Grupo 7992",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3011",
    "data-name": "Trazado 3011",
    d: "M1829.772,1803.263a5.425,5.425,0,0,0-1.643,3.8,4.106,4.106,0,0,0,1.765,3.515s7.294,3.128,18.438-.04c0,0,3.042-4.434-.827-6.555C1847.5,1803.982,1835.681,1806.434,1829.772,1803.263Z",
    transform: "translate(-1828.127 -1803.263)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7995",
    "data-name": "Grupo 7995",
    transform: "translate(1979.181 1316.282)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7994",
    "data-name": "Grupo 7994",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3012",
    "data-name": "Trazado 3012",
    d: "M1828.35,1817.574a4.1,4.1,0,0,0,1.764,3.512s7.293,3.13,18.44-.039a7.234,7.234,0,0,0,1.122-3.1c-.048.084-.08.128-.08.128a31.824,31.824,0,0,1-16.92.536,4.338,4.338,0,0,1-3.28-3.931c0-.025,0-.051,0-.077a.783.783,0,0,1,0-.128A5.07,5.07,0,0,0,1828.35,1817.574Z",
    transform: "translate(-1828.348 -1814.471)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7997",
    "data-name": "Grupo 7997",
    transform: "translate(1978.413 1314.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7996",
    "data-name": "Grupo 7996",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3013",
    "data-name": "Trazado 3013",
    d: "M1826.96,1798.681a36.677,36.677,0,0,0,10.041-1.457l.266-.076.156-.228c.07-.1,1.715-2.536,1.153-4.894a4.245,4.245,0,0,0-2.244-2.767l-.247-.136-.277.057c-.116.024-11.621,2.359-17.215-.644l-.478-.256-.4.366a6.184,6.184,0,0,0-1.892,4.389,4.861,4.861,0,0,0,2.159,4.16l.07.034A24.2,24.2,0,0,0,1826.96,1798.681Zm9.338-2.851c-10.162,2.806-16.992.253-17.6.011a3.428,3.428,0,0,1-1.345-2.853,4.4,4.4,0,0,1,1.052-2.831c5.73,2.643,15.563.941,17.422.584a2.635,2.635,0,0,1,1.257,1.637A5.193,5.193,0,0,1,1836.3,1795.829Z",
    transform: "translate(-1815.82 -1788.281)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7999",
    "data-name": "Grupo 7999",
    transform: "translate(1973.284 1339.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7998",
    "data-name": "Grupo 7998",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3014",
    "data-name": "Trazado 3014",
    d: "M1944.641,2202.071a.972.972,0,0,0,0-1.943c-6.305,0-16.889-1.119-18.447-4.114a.972.972,0,1,0-1.724.9C1927.079,2201.926,1942.851,2202.071,1944.641,2202.071Z",
    transform: "translate(-1924.361 -2195.49)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8001",
    "data-name": "Grupo 8001",
    transform: "translate(2018.799 1324.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8000",
    "data-name": "Grupo 8000",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3015",
    "data-name": "Trazado 3015",
    d: "M1152.455,1964.385a.971.971,0,0,0,.8-.422c5.323-7.761,10.71-10.669,14.292-11.743a13.328,13.328,0,0,1,6.53-.486.972.972,0,0,0,.5-1.878c-.483-.129-11.95-2.991-22.925,13.007a.972.972,0,0,0,.8,1.521Z",
    transform: "translate(-1151.484 -1949.579)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8006",
    "data-name": "Grupo 8006",
    transform: "translate(2026.585 1349.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8003",
    "data-name": "Grupo 8003",
    transform: "translate(0.481 1.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8002",
    "data-name": "Grupo 8002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3016",
    "data-name": "Trazado 3016",
    d: "M1237.594,2359.19s-3.876,2.4-10.865.518",
    transform: "translate(-1226.728 -2359.19)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8005",
    "data-name": "Grupo 8005",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8004",
    "data-name": "Grupo 8004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3017",
    "data-name": "Trazado 3017",
    d: "M1220.745,2342.994c-.032.024-.135.085-.215.128s-.178.093-.268.139c-.186.087-.375.177-.574.251a10.184,10.184,0,0,1-1.222.4,14.336,14.336,0,0,1-2.595.415c-.443.02-.887.046-1.334.029-.447.005-.894-.037-1.342-.069s-.893-.111-1.342-.163c-.445-.077-.889-.169-1.336-.252l-.032-.006a.485.485,0,0,0-.221.944c.455.128.91.264,1.37.385.465.1.927.222,1.4.3s.944.162,1.424.2c.478.06.96.075,1.444.094a15.894,15.894,0,0,0,2.921-.209,11.984,11.984,0,0,0,1.457-.337c.243-.067.483-.155.725-.244.121-.049.241-.092.365-.149a4.3,4.3,0,0,0,.4-.2l.033-.018a.975.975,0,1,0-1.057-1.633Z",
    transform: "translate(-1209.911 -2342.8)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8008",
    "data-name": "Grupo 8008",
    transform: "translate(1967.483 1354.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8007",
    "data-name": "Grupo 8007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3018",
    "data-name": "Trazado 3018",
    d: "M2194.425,2425.4a17.427,17.427,0,0,1-2.594-.221,13.691,13.691,0,0,1-2.492-.625,7.389,7.389,0,0,1-2.135-1.153,3.977,3.977,0,0,1-1.288-1.749.973.973,0,1,0-1.828.665c.01.029.023.059.036.086a5.846,5.846,0,0,0,.893,1.352,6.078,6.078,0,0,0,1.188,1.021,8.94,8.94,0,0,0,2.7,1.169,14.992,14.992,0,0,0,2.786.44,18.377,18.377,0,0,0,2.789-.015.486.486,0,0,0-.036-.969Z",
    transform: "translate(-2184.028 -2421.013)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8145",
    "data-name": "Grupo 8145",
    transform: "translate(1908.497 1247.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8010",
    "data-name": "Grupo 8010",
    transform: "translate(0.483 12.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8009",
    "data-name": "Grupo 8009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3019",
    "data-name": "Trazado 3019",
    d: "M2945.412,934.464a5.5,5.5,0,0,1-2.832-3.619h0c-.03-.13-.054-.264-.075-.4a.736.736,0,0,1,.515-.817l1.346-.4,2.789,3.9-.79,1.113A.727.727,0,0,1,2945.412,934.464Z",
    transform: "translate(-2942.497 -929.232)",
    fill: "#9da9b9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8012",
    "data-name": "Grupo 8012",
    transform: "translate(0.309 6.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8011",
    "data-name": "Grupo 8011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3020",
    "data-name": "Trazado 3020",
    d: "M2944.532,832.175l-2.432-1.207a.8.8,0,0,0-.818.065l-1.258.9a.8.8,0,0,0-.2,1.094l1.754,2.606",
    transform: "translate(-2939.689 -830.884)",
    fill: "#ff1b40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8014",
    "data-name": "Grupo 8014",
    transform: "translate(0.309 6.358)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8013",
    "data-name": "Grupo 8013",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3021",
    "data-name": "Trazado 3021",
    d: "M2944.123,832.659l-2.032-1.009a.8.8,0,0,0-.818.066l-1.258.9a.8.8,0,0,0-.248.287.8.8,0,0,1,.264-.974l1.258-.9a.8.8,0,0,1,.817-.066l2.433,1.207Z",
    transform: "translate(-2939.698 -830.882)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8016",
    "data-name": "Grupo 8016",
    transform: "translate(6.428 15.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8015",
    "data-name": "Grupo 8015",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3022",
    "data-name": "Trazado 3022",
    d: "M3042.312,978.962l-1.258.9a.8.8,0,0,1-1.1-.167l-1.9-2.5,2.6-1.027,1.633-.645.351,2.678v.015A.8.8,0,0,1,3042.312,978.962Z",
    transform: "translate(-3038.059 -975.517)",
    fill: "#ff1b40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8018",
    "data-name": "Grupo 8018",
    transform: "translate(6.428 15.937)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8017",
    "data-name": "Grupo 8017",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3023",
    "data-name": "Trazado 3023",
    d: "M3042.312,987.735l-1.258.9a.8.8,0,0,1-1.1-.167l-1.9-2.5,2.6-1.027.185-.063c-1.4,2.33-.5,2.782,1.8,2.1v.015A.8.8,0,0,1,3042.312,987.735Z",
    transform: "translate(-3038.059 -984.872)",
    fill: "#232323"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8020",
    "data-name": "Grupo 8020",
    transform: "translate(0.177 12.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8019",
    "data-name": "Grupo 8019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3024",
    "data-name": "Trazado 3024",
    d: "M2941.156,930.249a1.024,1.024,0,0,1-.512-.138,5.763,5.763,0,0,1-3.056-4.24,1.045,1.045,0,0,1,.732-1.155l1.346-.4a.306.306,0,0,1,.173.588l-1.346.4a.425.425,0,0,0-.3.477,5.116,5.116,0,0,0,2.757,3.8.424.424,0,0,0,.551-.126l.789-1.113a.307.307,0,1,1,.5.354l-.789,1.113A1.034,1.034,0,0,1,2941.156,930.249Z",
    transform: "translate(-2937.575 -924.308)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8022",
    "data-name": "Grupo 8022",
    transform: "translate(0 6.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8021",
    "data-name": "Grupo 8021",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3025",
    "data-name": "Trazado 3025",
    d: "M2936.926,831.312a.307.307,0,0,1-.255-.135l-1.754-2.606a1.1,1.1,0,0,1,.274-1.515l1.258-.9a1.1,1.1,0,0,1,1.132-.091l2.432,1.207a.307.307,0,1,1-.273.549l-2.432-1.207a.491.491,0,0,0-.5.04l-1.258.9a.488.488,0,0,0-.122.674l1.754,2.606a.307.307,0,0,1-.254.478Z",
    transform: "translate(-2934.728 -825.951)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8024",
    "data-name": "Grupo 8024",
    transform: "translate(6.121 15.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8023",
    "data-name": "Grupo 8023",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3026",
    "data-name": "Trazado 3026",
    d: "M3035.966,975.7a1.1,1.1,0,0,1-.879-.44l-1.9-2.5a.306.306,0,1,1,.488-.37l1.9,2.5a.49.49,0,0,0,.677.1l1.258-.9a.491.491,0,0,0,.2-.463l-.353-2.692a.307.307,0,0,1,.608-.08l.353,2.692a1.1,1.1,0,0,1-.453,1.042l-1.258.9A1.1,1.1,0,0,1,3035.966,975.7Z",
    transform: "translate(-3033.13 -970.591)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8026",
    "data-name": "Grupo 8026",
    transform: "translate(2.089 0.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8025",
    "data-name": "Grupo 8025",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3027",
    "data-name": "Trazado 3027",
    d: "M2973,750.225a1.294,1.294,0,0,1-1.328-.28,14.125,14.125,0,0,1-3.255-4.54,1.287,1.287,0,0,1,.177-1.322c.048-.061.1-.121.145-.18h0q6.062-7.5,12.416-9.557a15.5,15.5,0,0,1,6.727-.657,1.389,1.389,0,0,1,1.193,1.67q-.143.679-.344,1.337a15.561,15.561,0,0,1-2.46,4.812Q2982.221,746.911,2973,750.225Z",
    transform: "translate(-2968.308 -733.573)",
    fill: "#f6f6f6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8028",
    "data-name": "Grupo 8028",
    transform: "translate(14.873 0.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8027",
    "data-name": "Grupo 8027",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3028",
    "data-name": "Trazado 3028",
    d: "M3179,741.508c-2.972-.794-5.614-4.58-5.115-7.162a15.5,15.5,0,0,1,6.727-.657,1.39,1.39,0,0,1,1.193,1.67A15.485,15.485,0,0,1,3179,741.508Z",
    transform: "translate(-3173.828 -733.573)",
    fill: "#ff1b40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8030",
    "data-name": "Grupo 8030",
    transform: "translate(14.873 0.305)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8029",
    "data-name": "Grupo 8029",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3029",
    "data-name": "Trazado 3029",
    d: "M3181.427,736.812c.053-.207.1-.414.146-.624a1.39,1.39,0,0,0-1.192-1.67,15.458,15.458,0,0,0-6.551.6,3.539,3.539,0,0,1,.059-.774,15.5,15.5,0,0,1,6.727-.657,1.389,1.389,0,0,1,1.193,1.67Q3181.652,736.1,3181.427,736.812Z",
    transform: "translate(-3173.827 -733.573)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8032",
    "data-name": "Grupo 8032",
    transform: "translate(2.089 3.425)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8031",
    "data-name": "Grupo 8031",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3030",
    "data-name": "Trazado 3030",
    d: "M2973,797.261a1.294,1.294,0,0,1-1.328-.28,14.124,14.124,0,0,1-3.255-4.54,1.287,1.287,0,0,1,.177-1.321c.048-.061.1-.121.145-.18,8.711,4.682,19.99-7.211,19.99-7.211v0a15.559,15.559,0,0,1-2.46,4.812Q2982.221,793.947,2973,797.261Z",
    transform: "translate(-2968.308 -783.728)",
    fill: "#232323"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8034",
    "data-name": "Grupo 8034",
    transform: "translate(1.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8033",
    "data-name": "Grupo 8033",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3031",
    "data-name": "Trazado 3031",
    d: "M2967.919,746.009a1.594,1.594,0,0,1-1.1-.442,14.521,14.521,0,0,1-3.324-4.638,1.585,1.585,0,0,1,.218-1.637c6.243-7.8,12.826-11.332,19.563-10.507a1.7,1.7,0,0,1,1.456,2.038c-1.4,6.639-6.878,11.716-16.27,15.091h0A1.608,1.608,0,0,1,2967.919,746.009Zm.439-.384h0Zm13.013-16.344c-5.882,0-11.652,3.488-17.181,10.394a.974.974,0,0,0-.135,1.006,13.721,13.721,0,0,0,3.186,4.442.981.981,0,0,0,1.013.214h0c9.178-3.3,14.52-8.224,15.877-14.641a1.083,1.083,0,0,0-.93-1.3A15.07,15.07,0,0,0,2981.372,729.281Z",
    transform: "translate(-2963.36 -728.667)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8036",
    "data-name": "Grupo 8036",
    transform: "translate(2.823 11.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8035",
    "data-name": "Grupo 8035",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3032",
    "data-name": "Trazado 3032",
    d: "M2980.237,915.132h0a.673.673,0,0,1,.157-.938l3.576-2.554a.673.673,0,0,1,.938.156h0a.673.673,0,0,1-.156.938l-3.576,2.554A.673.673,0,0,1,2980.237,915.132Z",
    transform: "translate(-2980.111 -911.514)",
    fill: "#ff1b40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8038",
    "data-name": "Grupo 8038",
    transform: "translate(2.823 11.374)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8037",
    "data-name": "Grupo 8037",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3033",
    "data-name": "Trazado 3033",
    d: "M2985.016,912.331a.579.579,0,0,0-.032-.05.672.672,0,0,0-.937-.156l-3.576,2.554a.664.664,0,0,0-.264.4.672.672,0,0,1,.188-.89l3.575-2.554a.673.673,0,0,1,1.055.658A.336.336,0,0,1,2985.016,912.331Z",
    transform: "translate(-2980.112 -911.512)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8040",
    "data-name": "Grupo 8040",
    transform: "translate(2.516 11.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8039",
    "data-name": "Grupo 8039",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3034",
    "data-name": "Trazado 3034",
    d: "M2976.162,911.1a.986.986,0,0,1-.163-.013.972.972,0,0,1-.636-.4h0a.979.979,0,0,1,.228-1.366l3.576-2.554a.979.979,0,1,1,1.138,1.594l-3.576,2.554A.973.973,0,0,1,2976.162,911.1Zm3.573-3.9a.363.363,0,0,0-.212.068l-3.576,2.554a.366.366,0,0,0-.085.51h0a.365.365,0,0,0,.51.085l3.576-2.554a.366.366,0,0,0-.153-.659A.379.379,0,0,0,2979.735,907.2Z",
    transform: "translate(-2975.181 -906.586)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8042",
    "data-name": "Grupo 8042",
    transform: "translate(9.53 5.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8041",
    "data-name": "Grupo 8041",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_284",
    "data-name": "Elipse 284",
    cx: 2.775,
    cy: 2.775,
    r: 2.775,
    fill: "#ff1b40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8044",
    "data-name": "Grupo 8044",
    transform: "translate(9.53 6.951)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8043",
    "data-name": "Grupo 8043",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3035",
    "data-name": "Trazado 3035",
    d: "M3092.322,844.339a2.775,2.775,0,0,1-3.829-3.927,2.774,2.774,0,0,0,4.905,2.351A2.763,2.763,0,0,1,3092.322,844.339Z",
    transform: "translate(-3087.934 -840.412)",
    fill: "#232323"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8046",
    "data-name": "Grupo 8046",
    transform: "translate(9.593 5.845)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8045",
    "data-name": "Grupo 8045",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3036",
    "data-name": "Trazado 3036",
    d: "M3094.19,826.545a2.774,2.774,0,0,0-5.244-1.722,2.775,2.775,0,1,1,5.244,1.722Z",
    transform: "translate(-3088.946 -822.637)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8048",
    "data-name": "Grupo 8048",
    transform: "translate(9.223 5.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8047",
    "data-name": "Grupo 8047",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3037",
    "data-name": "Trazado 3037",
    d: "M3086.087,823.869a3.114,3.114,0,0,1-.513-.043,3.081,3.081,0,1,1,2.3-.532h0A3.059,3.059,0,0,1,3086.087,823.869Zm-.012-5.55a2.468,2.468,0,1,0,1.439,4.477h0a2.468,2.468,0,0,0-1.028-4.443A2.5,2.5,0,0,0,3086.075,818.319Zm1.618,4.726h0Z",
    transform: "translate(-3082.999 -817.706)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8050",
    "data-name": "Grupo 8050",
    transform: "translate(9.98 6.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8049",
    "data-name": "Grupo 8049",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_285",
    "data-name": "Elipse 285",
    cx: 1.715,
    cy: 1.715,
    rx: 1.715,
    ry: 1.715,
    transform: "translate(0 1.633) rotate(-28.421)",
    fill: "#45c1f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8052",
    "data-name": "Grupo 8052",
    transform: "translate(10.714 6.905)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8051",
    "data-name": "Grupo 8051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3038",
    "data-name": "Trazado 3038",
    d: "M3109.768,842.6a1.714,1.714,0,0,0-2.8-1.856,1.715,1.715,0,1,1,2.8,1.856Z",
    transform: "translate(-3106.967 -839.67)",
    fill: "#232323"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8054",
    "data-name": "Grupo 8054",
    transform: "translate(10.436 6.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8053",
    "data-name": "Grupo 8053",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3039",
    "data-name": "Trazado 3039",
    d: "M3104.369,840.96a1.867,1.867,0,1,1,1.083-.347h0A1.858,1.858,0,0,1,3104.369,840.96Zm-.005-3.429a1.562,1.562,0,1,0,.91,2.832h0a1.561,1.561,0,0,0-.91-2.832Z",
    transform: "translate(-3102.498 -837.225)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8056",
    "data-name": "Grupo 8056",
    transform: "translate(14.567 0.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8055",
    "data-name": "Grupo 8055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3040",
    "data-name": "Trazado 3040",
    d: "M3174.4,748.857a.3.3,0,0,1-.079-.011c-3.078-.822-5.871-4.756-5.337-7.516a.307.307,0,0,1,.6.117c-.473,2.444,2.134,6.07,4.893,6.807a.307.307,0,0,1-.079.6Z",
    transform: "translate(-3168.915 -741.083)",
    fill: "#371a45"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8058",
    "data-name": "Grupo 8058",
    transform: "translate(0.566 14.089)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8057",
    "data-name": "Grupo 8057"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3041",
    "data-name": "Trazado 3041",
    d: "M2946.666,958.782a5.5,5.5,0,0,1-2.832-3.619c.856,1.4,3.01,1.015,3.01,1.015l.785.184.78,1.092-.789,1.113A.728.728,0,0,1,2946.666,958.782Z",
    transform: "translate(-2943.834 -955.163)",
    fill: "#232323"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8060",
    "data-name": "Grupo 8060",
    transform: "translate(1896.961 1236.439)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8059",
    "data-name": "Grupo 8059",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3042",
    "data-name": "Trazado 3042",
    d: "M2753.186,567.084a13.889,13.889,0,0,1,9.574-2.2c5.723.944,10.079,3.507,17.433,3.024,9.066-.6,15.394-10.892,15.394-10.892s-6.379-18.682-6.29-26.107a10.265,10.265,0,0,0-3.232.918c.653,6.949,6.947,24.722,2.2,28.922-8.389,7.419-14.5-10.108-15.534-20.755a8.377,8.377,0,0,1-2.119.236,9.967,9.967,0,0,1-2.188-.292c2.632,8.346,5.87,22.506-2.851,21.489-9.884-1.153-8.543-17.246-14.482-26.193-.564.089-1.15.206-1.758.357C2749.329,535.587,2753.294,566.888,2753.186,567.084Z",
    transform: "translate(-2749.329 -530.905)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8159",
    "data-name": "Grupo 8159",
    transform: "translate(45.145 196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8159-2",
    "data-name": "Grupo 8159",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3159",
    "data-name": "Trazado 3159",
    d: "M10.229,1.64a5.531,5.531,0,0,1,1.3,7.151L8.861,6.4a2.345,2.345,0,0,0-.714-2.514c-1.138-1.021-2.679-.805-3.905.561S2.957,7.376,4.095,8.4a2.342,2.342,0,0,0,2.575.438l2.669,2.4a5.533,5.533,0,0,1-7.25-.524,5.728,5.728,0,0,1-.364-8.525,5.723,5.723,0,0,1,8.5-.544",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3160",
    "data-name": "Trazado 3160",
    d: "M15.451,18.881l-3.41-2.537-1.685,1.183-2.81-2.091L18.2,8.428l3.083,2.293L17.626,22.935l-2.823-2.1Zm2.131-6.425-3.337,2.349,2.06,1.532Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3161",
    "data-name": "Trazado 3161",
    d: "M25.517,23.021l-1.408-.859L22,25.616l-2.844-1.735L25.4,13.652l4.252,2.592c2.54,1.549,2.955,3.774,1.751,5.746-1.088,1.786-3.286,2.615-5.883,1.031m1.1-2.432a1.3,1.3,0,1,0,1.354-2.22l-1.132-.69L25.489,19.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_552",
    "data-name": "Rect\\xE1ngulo 552",
    width: 11.986,
    height: 3.332,
    transform: "translate(28.919 29.622) rotate(-62.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3162",
    "data-name": "Trazado 3162",
    d: "M38.182,21.013l8.906,3.827-1.047,2.438L43.1,26.015l-3.686,8.578-3.062-1.315L40.041,24.7l-2.906-1.249Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3163",
    "data-name": "Trazado 3163",
    d: "M52.193,36.912l-4.074-1.206L46.945,37.4,43.588,36.4l7.588-10.249,3.683,1.09.772,12.722-3.373-1Zm-.214-6.763L49.657,33.5l2.461.728Zm4.41-7.539-.713,2.412-4.547.391.641-2.167Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3164",
    "data-name": "Trazado 3164",
    d: "M70.47,30.137,68.749,41.992l-3.3-.478-3.427-7.263-.962,6.625L57.769,40.4,59.49,28.543l3.295.479L66.2,36.368l.974-6.71Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3165",
    "data-name": "Trazado 3165",
    d: "M85.807,32.6l-4.331.172.077,1.953,3.821-.151.1,2.53-3.821.151.086,2.157,4.33-.171.106,2.666-7.66.3-.473-11.972,7.66-.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3166",
    "data-name": "Trazado 3166",
    d: "M92.907,41.34c-2.65.313-4.858-.708-5.295-3.24l3.527-.418a1.133,1.133,0,0,0,1.34,1.056c.591-.07,1.011-.427.944-.985-.243-1.9-5.908-.326-6.347-4.467-.276-2.329,1.517-3.807,4.031-4.1,2.734-.324,4.681.8,5.079,3.145l-3.594.426a1.03,1.03,0,0,0-1.226-.95.794.794,0,0,0-.777.948c.21,1.772,5.863.521,6.315,4.334.248,2.093-1.179,3.922-4,4.256",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3167",
    "data-name": "Trazado 3167",
    d: "M103.592,35.337l-1.613.341.835,3.958-3.26.689L97.08,28.6l4.874-1.028c2.91-.615,4.738.719,5.215,2.981.432,2.046-.6,4.157-3.577,4.785m-.863-2.527c.981-.207,1.275-.79,1.114-1.556a1.209,1.209,0,0,0-1.651-.989l-1.3.274.537,2.544Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3168",
    "data-name": "Trazado 3168",
    d: "M117.5,33.648l-4.043,1.309-.013,2.058-3.332,1.078.467-12.748,3.655-1.182,7.83,10.063-3.348,1.083Zm-4-5.46-.02,4.08,2.442-.79Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3169",
    "data-name": "Trazado 3169",
    d: "M123.913,20.141a5.533,5.533,0,0,1,7.079,1.647l-3.259,1.5a2.34,2.34,0,0,0-2.589-.344c-1.39.638-1.8,2.137-1.038,3.805.773,1.684,2.181,2.346,3.571,1.707a2.34,2.34,0,0,0,1.425-2.188l3.259-1.5A5.531,5.531,0,0,1,129,31.212a5.727,5.727,0,0,1-7.967-3.052,5.723,5.723,0,0,1,2.88-8.019",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_553",
    "data-name": "Rect\\xE1ngulo 553",
    width: 3.334,
    height: 11.991,
    transform: "matrix(0.87, -0.493, 0.493, 0.87, 130.174, 17.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3170",
    "data-name": "Trazado 3170",
    d: "M146.4,18.823l-3.51,2.4.569,1.978-2.892,1.975-3.148-12.36,3.173-2.165,10.349,7.443-2.906,1.983Zm-5.377-4.108,1.132,3.919,2.119-1.446Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3171",
    "data-name": "Trazado 3171",
    d: "M147.154,5.54l6.063,7.232,2.854-2.392,1.639,1.955L152.3,16.868l-7.7-9.186Z",
    fill: "#fff"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_551",
    "data-name": "Rect\\xE1ngulo 551",
    width: 248,
    height: 248,
    transform: "translate(0 0)",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitan);
export default __webpack_public_path__ + "static/media/Capitan.31c8c0e2a2e3056b2625708f0380d1a5.svg";
export { ForwardRef as ReactComponent };